<template>
  <div class="modal fade" tabindex="-1" aria-hidden="true">
    <div v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' && $route.fullPath.includes('myproducts')"
      class="modal-dialog modal-dialog-centered modal-sticky-lg modal-fullscreen">
      <div class="modal-content rounded">
        <div class="modal-header border-gray-300 shadow-sm">
          <h2 class="fw-bolder">
            {{ modalInfo.status ? contents.createTitle : contents.updateTitle }}
            {{ contents.title }}
          </h2>
          <!--begin::Description-->
          <!-- <div class="text-gray-400 fw-bold fs-5">
            {{ contents.subTitle.length ? contents.subTitle : "" }}
            <a href="#" class="fw-bolder link-primary">{{
              contents.subTitleLink.length ? contents.subTitleLink : ""
            }}</a>
          </div> -->
          <!--end::Description-->
          <div class="btn btn-icon btn-sm btn-active-icon-primary" @click="closeModal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                  fill="black" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
              </svg>
            </span>
          </div>
        </div>
        <div style="max-height: 90%" class="modal-body scroll-y">
          <div
            class="mt-10 mt-lg-0 d-flex flex-row justify-content-around align-items-center pb-3 border-bottom border-dark scroll-x gap-3">
            <div class="rounded p-5 col-12 col-lg-3 d-flex flex-column justify-content-start align-items-center w-100">
              <div class="d-none d-lg-flex flex-row mt-5 justify-content-center w-100 pb-3">
                <div v-for="(s, si) in vidisciObj.steps" :key="si"
                  class="d-flex flex-row align-items-start justify-center-start" :class="si == 0 ? 'col-1' : 'col'">
                  <div v-if="si > 0" class="border border-secondary m-auto steps__connector col-6"></div>
                  <button v-if="si == 0" style="min-height: 100px;"
                    class="col-12 p-3 text-start btn btn-outline rounded text-center"
                    :class="vidisciObj.step == si ? 'active btn-primary' : 'btn-secondary'" @click="setVidisciStep(si)">
                    {{ s.title }}
                  </button>
                  <button v-else style="min-height: 100px;"
                    class="col-6 p-3 text-start btn btn-outline rounded text-center"
                    :class="vidisciObj.step == si ? 'active btn-primary' : 'btn-secondary'" @click="setVidisciStep(si)">
                    {{ s.title }}
                  </button>
                </div>
              </div>
              <div class="d-lg-none d-flex flex-row mt-5 justify-content-between w-100 pb-3">
                <button v-if="vidisciObj.step > 0" style="min-height: 100px;"
                  class="col-2 p-3 text-start btn btn-outline rounded text-center"
                  @click="setVidisciStep(vidisciObj.step - 1)">
                  Previous Step
                </button>
                <button style="min-height: 100px;"
                  class="col-4 p-0 text-start btn btn-outline rounded text-center btn-primary">
                  {{ vidisciObj.steps[vidisciObj.step].title }}
                </button>
                <button v-if="vidisciObj.step < vidisciObj.steps.length" style="min-height: 100px;"
                  class="col-2 p-3 text-start btn btn-outline rounded text-center"
                  @click="setVidisciStep(vidisciObj.step + 1)">
                  Next Step
                </button>
              </div>
            </div>
            <!-- <button v-for="(s, si) in vidisciObj.steps" :key="s.name" class="w-100px d-flex flex-column btn"
              :class="vidisciObj.step == si ? 'btn-primary' : 'btn-secondary'" @click="setVidisciStep(si)">
              <span>
                Step {{ si + 1 }}
              </span>
              {{ s.title }}
            </button> -->
          </div>
          <div class="mt-3">
            <div v-if="vidisciObj.step == 0">
              <h3>
                {{ contents.fields[0].title }}
              </h3>
              <div class="d-flex flex-row justify-content-between">
                <div class="mt-20 mt-md-0 col-12 row justify-content-between" data-kt-buttons="true">
                  <!--begin::Radio button-->
                  <label v-for="(option, index) in contents.fields[0].options" :key="index"
                    :class="index == 0 ? 'active' : ''" class="col-12 col-md-6 d-flex flex-column text-start p-2">
                    <div class="btn btn-outline btn-outline-dashed p-6">
                      <div class="d-flex flex-row align-items-center me-2">
                        <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                          <input class="form-check-input" type="radio" name="plan"
                            @click="setSelectedUpload(option.value, option)" />
                        </div>
                        <h4 class="">
                          {{ option.title }}
                        </h4>
                      </div>
                      <div class="w-100 mt-5 w-100 text-center">
                        {{ option.parse }}
                        <!-- Change it to video tag -->
                        <video controls
                          :poster="`${backendHost}/uploads/${$store.state.uploadsPath}/${option.parse.poster}`"
                          class="h-auto w-300px rounded" style="object-fit: cover; aspect-ratio: 16 / 9;" alt="">
                          <source :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${option.parse.video}`"
                            type="video/mp4">
                        </video>
                        <!-- <img v-if="option.uploadsPath"
                          :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${option.parse}`"
                          class="mh-150px mw-150px rounded" style="object-fit: cover" alt="" />
                        <img v-else :src="`${backendHost}/images/preview/${option.parse}`"
                          class="mh-150px mw-150px rounded" style="object-fit: cover" alt="" /> -->
                      </div>
                      <div class="mt-10 d-flex flex-row justify-content-between align-items-center px-3">
                        <span class="fs-1 text-primary">{{ option.info.price }}</span>
                        <span>EUR</span>
                      </div>
                    </div>
                  </label>
                  <!--end::Radio button-->
                </div>
                <div v-if="false"
                  class="mt-20 mb-md-0 position-fixed position-md-relative bg-secondary start-0 end-0 top-0 col-12 col-lg-6 d-md-flex flex-column p-10 border border-dashed border-secondary rounded">
                  <div class="d-flex flex-column" v-if="templateOption.status">
                    <h4>Template Description</h4>
                    <div class="d-flex flex-row flex-wrap mt-5">
                      <h5 class="fw-light">{{ templateOption.info.category }}</h5>
                      <span class="mx-2">-</span>
                      <h6 class="fw-light" v-for="(tag, index) in templateOption.info.tags" :key="tag">
                        {{ tag.tagName }}
                        <span v-if="index > 0" class="mx-2">-</span>
                      </h6>
                    </div>
                    <h5 class="fw-light mt-5">
                      {{ templateOption.info.summary }}
                    </h5>
                    <div class="mt-5" v-html="templateOption.info.description"></div>
                    <button class="btn btn-primary" @click="() => { templateOption.status = false }">Close</button>
                  </div>
                  <div v-else>
                    No template info to be displayed!
                  </div>
                </div>
              </div>
              <div v-if="contents.fields[0].required && contents.fields[0].errorCode > 0" id="validationErrorFeedback"
                class="invalid-feedback d-block">
                {{ field.validation[field.errorCode - 1].error }}
              </div>
            </div>
            <div v-if="vidisciObj.step == 1" class="d-flex flex-column">
              <div v-if="templateIndex !== ''">
                <div v-for="(fields, fsi) in info['blogBody'][templateIndex]" :key="fsi">
                  <div v-if="fsi > 0">
                    <div class="bg-light-info border border-secondary border-dashed py-5 px-3 rounded my-3">
                      Scene {{ fsi }} - {{ fields.sectionTitle }}
                    </div>
                    <div class="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                      <div class="d-flex justify-content-center align-items-center col-12 col-md-6">
                        <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${fields.sectionImage}`"
                          class="mw-300px mh-300px rounded" style="object-fit: contain; aspect-ratio: 16 / 9;" alt="" />
                      </div>
                      <div class="p-5 d-flex justify-content-center flex-column col-12 col-md-6">
                        <div v-if="templateIndex !== ''">
                          <div v-for="(f, index) in fields.sectionJson.fields" :key="index" class="fv-row mb-8">
                            <!--begin::Label-->
                            <label :ref="f.name" class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{ f.title }}</span>
                              <i class="bi bi-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                                title="Select your post image"></i>
                            </label>
                            <!--end::Label-->
                            <div v-if="f.type == 'selectFile'">
                              <!--begin::Input group-->
                              <div @click="setModalConfigs('choose')" class="fv-row">
                                <!--begin::Dropzone-->
                                <div class="dropzone dropzone__bg" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                  " id="kt_dropzonejs_example_1">
                                  <!--begin::Message-->
                                  <div v-if="info.photos" class="shadow symbol symbol-100px card mb-7">
                                    <img v-for="photo in info.photos" :key="photo"
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                  </div>
                                  <div v-else class="dz-message needsclick">
                                    <!--begin::Icon-->
                                    <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                    <!--end::Icon-->

                                    <!--begin::Info-->
                                    <div class="ms-4">
                                      <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                        Drop files here or click to upload.
                                      </h3>
                                      <span class="fs-7 fw-bold text-gray-400">Upload up to 10 files</span>
                                    </div>
                                    <!--end::Info-->
                                  </div>
                                </div>
                                <!--end::Dropzone-->
                              </div>
                              <!--end::Input group-->
                              <!-- <a
                                  class="btn btn-primary btn-shadow ms-2"
                                  :class="
                                    f.required && f.errorCode ? 'wrong-inputs' : ''
                                  "
                                  @click="setModalConfigs('choose')"
                                >
                                  انتخاب عکس
                                </a> -->
                              <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                                class="invalid-feedback d-block">
                                {{ f.validation[f.errorCode - 1].error }}
                              </div>
                            </div>
                            <div v-else-if="f.type == 'text'">
                              <input :ref="`${f.name}_Input`" :placeholder="f.placeholder" v-model="f.value"
                                id="postTitle" type="text" class="form-control form-control-solid" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                  " name="subject" />
                              <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                                class="invalid-feedback d-block">
                                {{ f.validation[f.errorCode - 1].error }}
                              </div>
                            </div>
                            <div v-else-if="f.type == 'description'">
                              <textarea :ref="`${f.name}_Input`" :placeholder="f.placeholder" v-model="f.value"
                                :id="f.name" rows="5" class="form-control form-control-solid" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                  " name="subject"></textarea>
                              <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                                class="invalid-feedback d-block">
                                {{ f.validation[f.errorCode - 1].error }}
                              </div>
                            </div>
                            <div v-else-if="f.type == 'textarea'" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                              ">
                              <editor v-model="f.value" :api-key="tinymceToken" :init="{
                                menubar: true,
                                plugins: 'lists link emoticons directionality',
                                directionality:
                                  info['blogLocale'] == 'fa' ? 'rtl' : 'ltr',
                                toolbar:
                                  'styleselect | bold italic | alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist | link emoticons',
                                height: 200,
                              }" />
                              <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                                class="invalid-feedback d-block">
                                {{ f.validation[f.errorCode - 1].error }}
                              </div>
                            </div>
                            <div id="chapterAccordion" :tabindex="index" v-if="f.type == 'card'">
                              <div v-for="(subField, index) in f.value.length" :key="subField"
                                class="card border border-gray-300 mb-5">
                                <div class="card-header">
                                  <!-- :class="index != 0 ? 'collapsed' : ''" -->
                                  <div class="card-title collapsible cursor-pointer text-hover-primary rotate"
                                    data-bs-toggle="collapse" :data-bs-target="`#kt_${f.name}_collapsible_${index}`">
                                    <span v-if="f.title.length > 0" class="fs-2 fw-bolder">{{ f.title }} {{ index + 1
                                    }}</span>
                                  </div>
                                  <div class="card-toolbar gap-3">
                                    <a href="#" @click="addComponentChild(f.value, f.default)"
                                      class="btn btn-sm btn-icon btn-light-primary"><i
                                        class="bi bi-folder-plus fs-3"></i></a>
                                    <a href="#" @click="delComponentChild(f.value, index)"
                                      class="btn btn-sm btn-icon btn-light-danger"><i class="bi bi-trash fs-3"></i></a>
                                    <div class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                                      :class="index != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                                      :data-bs-target="`#kt_${f.name}_collapsible_${index}`">
                                      <div class="rotate-180">
                                        <span class="svg-icon svg-icon-1">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                              d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                              fill="currentColor"></path>
                                          </svg>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div :id="`kt_${f.name}_collapsible_${index}`" data-bs-parent="#chapterAccordion"
                                  class="collapse" :class="index == 0 ? 'show' : ''">
                                  <div class="card-body">
                                    <div>
                                      <div v-for="(item, i) in f.fields" :key="i" class="fv-row mb-10">
                                        <div v-if="item.editable || modalInfo.status">
                                          <div v-if="item.type !== 'card'" class="d-flex justify-content-between">
                                            <label v-if="item.title.length > 0" class="fs-5 fw-bolder form-label mb-2">
                                              <span :class="item.required ? 'required' : ''
                                                ">{{ item.title }}
                                                {{ index + 1 }}</span>
                                            </label>
                                          </div>
                                          <div>
                                            <div :tabindex="index" v-if="item.type == 'text'">
                                              {{ item.errorCode }}
                                              <input :ref="`${item.name}_Input`" :minlength="item.minLength"
                                                :maxlength="item.maxLength" class="form-control form-control-solid p-4"
                                                :class="item.required && item.errorCode
                                                  ? 'wrong-inputs'
                                                  : ''
                                                  " :disabled="item.disabled ? true : false
                                                    " aria-describedby="validationErrorFeedback" :type="item.type"
                                                :placeholder="`${item.placeholder}`"
                                                v-model="f.value[index][item.name]" />
                                              <div v-if="
                                                item.required &&
                                                item.errorCode > 0
                                              " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                {{
                                                  item.validation[
                                                    item.errorCode - 1
                                                  ].error
                                                }}
                                              </div>
                                            </div>
                                            <div :tabindex="index" v-else-if="item.type == 'textarea'" :class="item.required && item.errorCode
                                              ? 'wrong-inputs'
                                              : ''
                                              ">
                                              <editor v-model="f.value[index][item.name]" :api-key="tinymceToken" :init="{
                                                menubar: f.menubar,
                                                plugins: f.plugins
                                                  ? f.plugins
                                                  : tinyMCE_Def.plugins,
                                                directionality: f.directionality,
                                                toolbar: f.toolbar
                                                  ? f.toolbar
                                                  : tinyMCE_Def.toolbar,
                                                height: 200,
                                              }" />
                                            </div>
                                            <div :tabindex="index" v-else-if="item.type == 'selectFile'">
                                              <div @click="
                                                setModalConfigs('choose', {
                                                  root: f.name,
                                                  index: index,
                                                  child: item.name,
                                                  depth: 3,
                                                })
                                                " class="fv-row">
                                                <!--begin::Dropzone-->
                                                <div
                                                  class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                                  id="kt_dropzonejs_example_1">
                                                  <!--begin::Message-->
                                                  {{ f.value[index][item.name] }}
                                                  <div v-if="
                                                    f.value &&
                                                    f.value[index][item.name]
                                                      .length > 0
                                                  " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                                    <div v-for="photo in [
                                                      f.value[index][item.name],
                                                    ]" :key="photo"
                                                      class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                                      <div class="symbol symbol-100px">
                                                        <img
                                                          :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div v-else class="dz-message needsclick">
                                                    <!--begin::Icon-->
                                                    <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                                    <!--end::Icon-->

                                                    <!--begin::Info-->
                                                    <div class="ms-4">
                                                      <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                        Click here to upload an
                                                        image
                                                      </h3>
                                                      <span class="fs-7 fw-bold text-gray-400">Upload up to 10
                                                        files</span>
                                                    </div>
                                                    <!--end::Info-->
                                                  </div>
                                                </div>
                                                <!--end::Dropzone-->
                                              </div>
                                              <!-- <a
                                                class="btn btn-primary btn-shadow ms-2"
                                                :class="
                                                  field.required && field.errorCode ? 'wrong-inputs' : ''
                                                "
                                                @click="setModalConfigs('choose')"
                                              >
                                                انتخاب عکس
                                              </a> -->
                                              <div v-if="
                                                field.required &&
                                                field.errorCode > 0
                                              " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                {{
                                                  field.validation[
                                                    field.errorCode - 1
                                                  ].error
                                                }}
                                              </div>
                                            </div>
                                            <div :id="`sessionAccordion_${index}`" :tabindex="index"
                                              v-if="item.type == 'card'">
                                              <div v-for="(subItem, iii) in info[
                                                field.name
                                              ][subField - 1][item.name].length" :key="subItem"
                                                class="card border mb-5">
                                                <div class="card-header">
                                                  <div @click="
                                                    nestedAccordion(
                                                      `sessionAccordion_${index}`,
                                                      `#kt_${item.title}_${index}_collapsible_${iii}`
                                                    )
                                                    "
                                                    class="card-title collapsible cursor-pointer text-hover-primary rotate"
                                                    :class="iii != 0 ? 'collapsed' : ''
                                                      " data-bs-toggle="collapse"
                                                    :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                                    <span v-if="item.title.length > 0" class="fs-2 fw-bolder">{{
                                                      item.title }}
                                                      {{ index + 1 }}.{{
                                                        iii + 1
                                                      }}</span>
                                                  </div>
                                                  <div class="card-toolbar gap-3">
                                                    <a href="#" @click="
                                                      addChild(
                                                        field.name,
                                                        subField - 1,
                                                        item.name,
                                                        item.value
                                                      )
                                                      " class="btn btn-sm btn-icon btn-light-primary"><i
                                                        class="bi bi-folder-plus fs-3"></i></a>
                                                    <a href="#" @click="
                                                      delChild(
                                                        field.name,
                                                        subField - 1,
                                                        item.name
                                                      )
                                                      " class="btn btn-sm btn-icon btn-light-danger"><i
                                                        class="bi bi-trash fs-3"></i></a>
                                                    <div @click="
                                                      nestedAccordion(
                                                        `sessionAccordion_${index}`,
                                                        `#kt_${item.title}_${index}_collapsible_${iii}`
                                                      )
                                                      " :id="`kt_${item.title}_${index}_collapsible_${iii}_button`"
                                                      class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                                                      :class="iii != 0 ? 'collapsed' : ''
                                                        " data-bs-toggle="collapse"
                                                      :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                                      <div class="rotate-180">
                                                        <span class="svg-icon svg-icon-white svg-icon-1">
                                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                              d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                                              fill="currentColor"></path>
                                                          </svg>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div :id="`kt_${item.title}_${index}_collapsible_${iii}`"
                                                  :data-bs-parent="`#sessionAccordion_${index}`" class="collapse"
                                                  :class="iii == 0 ? 'show' : ''">
                                                  <div class="card-body">
                                                    <div v-for="(
it, ii
                                                      ) in item.fields" :key="ii" class="fv-row mb-10">
                                                      <div v-if="
                                                        it.editable ||
                                                        modalInfo.status
                                                      ">
                                                        <div class="d-flex justify-content-between">
                                                          <label v-if="
                                                            it.title.length > 0
                                                          " class="fs-5 fw-bolder form-label mb-2">
                                                            <span :class="item.required
                                                              ? 'required'
                                                              : ''
                                                              ">{{ it.title }}
                                                              {{ index + 1 }}.{{
                                                                iii + 1
                                                              }}</span>
                                                          </label>
                                                          <div v-if="
                                                            info[field.name][
                                                            subField - 1
                                                            ][item.name][
                                                            subItem - 1
                                                            ][it.name] &&
                                                            info[field.name][
                                                              subField - 1
                                                            ][item.name][
                                                              subItem - 1
                                                            ][it.name].length &&
                                                            it.maxLength &&
                                                            it.maxLength !== -1
                                                          " class="d-flex justify-content-end text-secondary">
                                                            {{
                                                              info[field.name][
                                                                subField - 1
                                                              ][item.name][
                                                                subItem - 1
                                                              ][it.name].length
                                                            }}
                                                            /
                                                            {{ it.maxLength }}
                                                          </div>
                                                          <div v-else-if="
                                                            it.maxTags &&
                                                            it.maxTags !== -1
                                                          " class="d-flex justify-content-end text-secondary">
                                                            0 / {{ it.maxLength }}
                                                          </div>
                                                        </div>
                                                        <div :tabindex="index" v-if="it.type == 'text'">
                                                          {{ it.errorCode }}
                                                          <input :ref="`${it.name}_Input`" :minlength="it.minLength
                                                            " :maxlength="it.maxLength
                                                              " class="form-control form-control-solid p-4" :class="it.required &&
                                                                  it.errorCode
                                                                  ? 'wrong-inputs'
                                                                  : ''
                                                                  " :disabled="it.disabled
                                                                    ? true
                                                                    : false
                                                                    " aria-describedby="validationErrorFeedback"
                                                            :type="it.type" :placeholder="`${it.placeholder}`" v-model="info[field.name][
                                                              subField - 1
                                                            ][item.name][
                                                              subItem - 1
                                                            ][it.name]
                                                              " />
                                                          <div v-if="
                                                            it.required &&
                                                            it.errorCode > 0
                                                          " id="validationErrorFeedback"
                                                            class="invalid-feedback d-block">
                                                            {{
                                                              it.validation[
                                                                it.errorCode - 1
                                                              ].error
                                                            }}
                                                          </div>
                                                        </div>
                                                        <div :tabindex="index" v-else-if="
                                                          it.type == 'icon'
                                                        ">
                                                          {{ it.errorCode }}
                                                          <multiselect :close-on-select="true" :filter-results="false"
                                                            :min-chars="0" :resolve-on-load="true" :infinite="true"
                                                            :limit="10" :clear-on-search="true" :delay="0" mode="single"
                                                            :canDeselect="false" :hideSelected="true"
                                                            class="form-control form-control-solid p-5" :class="item.required &&
                                                              item.errorCode
                                                              ? 'wrong-inputs'
                                                              : ''
                                                              " :placeholder="item.placeholder
                                                                " label="title" v-model="info[field.name][
                                                                    subField - 1
                                                                  ][item.name][
                                                                    subItem - 1
                                                                  ][it.name]
                                                                    " :searchable="true" :options="async (
                                                                      query,
                                                                      i,
                                                                      r
                                                                    ) => {
                                                                      return await fetchIcons(
                                                                        query
                                                                      );
                                                                    }
                                                                      " @open="
                                                                      (select$) => {
                                                                        if (
                                                                          select$.noOptions
                                                                        ) {
                                                                          select$.resolveOptions();
                                                                        }
                                                                      }
                                                                    ">
                                                            <template v-slot:singlelabel="{
                                                              value,
                                                            }">
                                                              <div class="multiselect-single-label">
                                                                <i class="me-2" :class="value.value
                                                                  "></i>
                                                                {{ value.title }}
                                                              </div>
                                                            </template>
                                                            <template v-slot:option="{
                                                              option,
                                                            }">
                                                              <i class="me-2" :class="option.value
                                                                "></i>
                                                              {{ option.title }}
                                                            </template>
                                                          </multiselect>
                                                          <div v-if="
                                                            item.required &&
                                                            item.errorCode > 0
                                                          " id="validationErrorFeedback"
                                                            class="invalid-feedback d-block">
                                                            {{
                                                              item.validation[
                                                                item.errorCode - 1
                                                              ].error
                                                            }}
                                                          </div>
                                                        </div>
                                                        <div :tabindex="index" v-else-if="
                                                          it.type == 'selectFile'
                                                        ">
                                                          <div @click="
                                                            setModalConfigs(
                                                              'choose',
                                                              {
                                                                root: field.name,
                                                                index:
                                                                  subField - 1,
                                                                child: item.name,
                                                                childIndex:
                                                                  subItem - 1,
                                                                grandchild:
                                                                  it.name,
                                                                depth: 5,
                                                              }
                                                            )
                                                            " class="fv-row">
                                                            <!--begin::Dropzone-->
                                                            <div
                                                              class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                                              id="kt_dropzonejs_example_1">
                                                              <!--begin::Message-->
                                                              <div v-if="
                                                                info[field.name][
                                                                subField - 1
                                                                ][item.name][
                                                                subItem - 1
                                                                ][it.name] &&
                                                                info[field.name][
                                                                  subField - 1
                                                                ][item.name][
                                                                  subItem - 1
                                                                ][it.name]
                                                                  .length > 0
                                                              " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                                                <div v-for="photo in info[
                                                                  field.name
                                                                ][subField - 1][
                                                                  item.name
                                                                ][subItem - 1][
                                                                  it.name
                                                                ]" :key="photo"
                                                                  class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6 col-md-3">
                                                                  <div class="symbol symbol-100px">
                                                                    <img
                                                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div v-else class="dz-message needsclick">
                                                                <!--begin::Icon-->
                                                                <i
                                                                  class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                                                <!--end::Icon-->

                                                                <!--begin::Info-->
                                                                <div class="ms-4">
                                                                  <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                                    Drop files here
                                                                    or click to
                                                                    upload.
                                                                  </h3>
                                                                  <span class="fs-7 fw-bold text-gray-400">Upload up to
                                                                    10
                                                                    files</span>
                                                                </div>
                                                                <!--end::Info-->
                                                              </div>
                                                            </div>
                                                            <!--end::Dropzone-->
                                                          </div>
                                                          <div v-if="
                                                            field.required &&
                                                            field.errorCode > 0
                                                          " id="validationErrorFeedback"
                                                            class="invalid-feedback d-block">
                                                            {{
                                                              field.validation[
                                                                field.errorCode - 1
                                                              ].error
                                                            }}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="separator separator-content separator-dashed mb-20 my-15 border-gray-300 text-primary text-nowrap">
                                                      End of Session
                                                      {{ index + 1 }}.{{ iii + 1 }}
                                                    </div>
                                                    <div v-if="
                                                      field.required &&
                                                      field.errorCode > 0
                                                    " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                      {{
                                                        field.validation[
                                                          field.errorCode - 1
                                                        ].error
                                                      }}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                                      class="invalid-feedback d-block">
                                      {{
                                        field.validation[field.errorCode - 1].error
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else
                          class="min-h-50px d-flex justify-content-center align-items-center text-danger fw-bold fs-2 text-center border-dotted">
                          Choose a template
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h2 v-else class="text-danger text-center">
                Please choose your template.
              </h2>
            </div>
            <div v-else-if="vidisciObj.step == 2" class="d-flex flex-center">
              In progress...
            </div>
            <div v-else-if="vidisciObj.step == 3" class="d-flex flex-center">
              In progress...
            </div>
            <div v-else-if="vidisciObj.step == 4" class="d-flex flex-center flex-column">
              <h2>
                Are you ready for rendering your video?
              </h2>
              <div class="d-flex flex-column justify-content-center gap-5 mt-10">
                {{ shareType }}
                <div class="form-check">
                  <!-- @click="setRadioGroup(field, option.value, true)" -->
                  <input class="form-check-input" value="false" v-model="shareType" type="radio" name="shareRB"
                    id="shareRB_1" />
                  <label class="form-check-label" for="shareRB_1">
                    Download the video with the logo
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" value="true" v-model="shareType" type="radio" name="shareRB"
                    id="shareRB_2" />
                  <label class="form-check-label" for="shareRB_2">
                    Download the video without logo and share it in website
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" value="false" v-model="shareType" type="radio" name="shareRB"
                    id="shareRB_3" />
                  <label class="form-check-label" for="shareRB_3">
                    Download the video without logo 5$
                  </label>
                </div>
                <!-- <button class="btn btn-primary" @click="closeModal('validate', info)">
                  Download the video with the logo
                </button>
                <button class="btn btn-outline-primary" @click="closeModal('validate', info)">
                  Download the video without logo and share it in website
                </button>
                <button class="btn btn-outline-primary" disabled>
                  Download the video without logo 5$
                </button> -->
              </div>
              <div v-if="templateIndex !== '' && shareType == 'true'" class="w-100">
                <div v-for="(field, index) in info['blogBody'][templateIndex][0].sectionJson.fields" :key="index"
                  class="mb-10 d-flex flex-column">
                  <div v-if="field.showable">
                    <label v-if="field.title.length > 0" class="fs-5 fw-bolder form-label mb-2">
                      <span :class="field.required ? 'required' : ''">{{
                        field.title
                      }}</span>
                    </label>
                    <div :tabindex="index" v-if="field.type == 'text'">
                      <input :ref="`${field.name}_Input`" :minlength="field.minLength" :maxlength="field.maxLength"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                            ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        :type="field.type" :placeholder="`${field.placeholder}`" v-model="field.value" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'number'">
                      <input :ref="`${field.name}_Input`" :min="field.min" :max="field.max" :step="field.steps"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                            ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        type="number" :placeholder="`${field.placeholder}`" v-model="field.value" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'summary'">
                      <textarea :dir="inlineRouteLocale == 'fa' ? 'rtl' : 'ltr'" :ref="`${field.name}_Input`"
                        :placeholder="field.placeholder" v-model="field.value" :id="field.name" :rows="field.rows"
                        class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " name="subject"></textarea>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'combobox'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true"
                        class="form-control form-control-solid p-5" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " :placeholder="field.placeholder" label="title" v-model="field.value" :searchable="true"
                        :options="field.options">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'multiselect'">
                      <div v-if="
                        info[field.name] &&
                        info[field.name].length &&
                        field.maxTags !== -1
                      " class="d-flex justify-content-end text-secondary">
                        {{ info[field.name].length }} / {{ field.maxTags }}
                      </div>
                      <div v-else-if="field.maxTags !== -1" class="d-flex justify-content-end text-secondary">
                        0 / {{ field.maxTags }}
                      </div>
                      <multiselect class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " v-model="field.value" :placeholder="field.placeholder" mode="tags" :max="field.maxTags"
                        label="title" :close-on-select="false" :searchable="true" :options="field.options" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'file'">
                      <div v-if="!modalInfo.status" class="symbol symbol-100px symbol-circle mb-7">
                        <img :src="info[field.name]
                          ? `${backendHost}/uploads/${$store.state.uploadsPath
                          }/${info[field.name]}`
                          : `${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`
                          " alt="image" id="photoPreview" />
                      </div>
                      <div v-else id="photoPreview" class="d-none"></div>
                      <!--begin::Notice-->
                      <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                        <!--begin::Icon-->
                        <!--begin::Svg Icon | -->
                        <i class="bi bi-file-earmark-arrow-up text-primary fs-3x me-2"></i>
                        <!--end::Svg Icon-->
                        <!--end::Icon-->
                        <!--begin::Wrapper-->
                        <div class="d-flex flex-stack flex-grow-1">
                          <!--begin::Content-->
                          <form class="form" :class="field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                            " action="#" method="post">
                            <!--begin::Input group-->
                            <div class="form-group row">
                              <!--begin::Col-->
                              <div class="col-12">
                                <!--begin::Dropzone-->
                                <div class="dropzone dropzone-queue mb-2" id="kt_dropzonejs_example_2">
                                  <!--begin::Controls-->
                                  <div class="d-flex">
                                    <div class="dropzone-panel mb-lg-0 mb-2">
                                      <a class="dropzone-select btn btn-sm btn-primary me-2">الصاق فایل</a>
                                      <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                      <a class="dropzone-remove-all btn btn-sm btn-light-primary me-2">حذف همه</a>
                                    </div>
                                    <a class="dropzone-photo-delete btn btn-sm btn-danger"
                                      :class="modalInfo.status ? 'd-none' : ''"
                                      @click="deleteFilePhoto(field.name)">حذف</a>
                                  </div>
                                  <!--end::Controls-->

                                  <!--begin::Items-->
                                  <div class="dropzone-items d-flex flex-wrap w-100 gap-2">
                                    <div class="dropzone-item bg-light border border-primary border-dashed w-150px"
                                      style="display: none">
                                      <!--begin::File-->
                                      <div class="dropzone-file w-100 mt-5">
                                        <div class="image-input" data-kt-image-input="true">
                                          <div class="image-input-wrapper">
                                            <img data-dz-thumbnail="" class="dz-image" alt="" />
                                          </div>
                                          <!--begin::Edit button-->
                                          <label
                                            class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow dropzone-delete"
                                            data-dz-remove data-kt-image-input-action="change" data-bs-toggle="tooltip"
                                            data-bs-dismiss="click">
                                            <i class="bi bi-trash-fill fs-7"></i>
                                          </label>
                                          <!--end::Edit button-->
                                        </div>
                                        <div class="dropzone-filename d-flex" title="some_image_file_name.jpg">
                                          <div class="w-50 turncating">
                                            <span data-dz-name>some_image_file_name.jpg</span>
                                          </div>
                                          <strong class="W-50">(<span data-dz-size>340kb</span>)</strong>
                                        </div>
                                        <div class="dropzone-error" data-dz-errormessage></div>
                                      </div>
                                      <!--end::File-->

                                      <!--begin::Progress-->
                                      <div class="dropzone-progress">
                                        <div class="progress">
                                          <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                            aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                        </div>
                                      </div>
                                      <!--end::Progress-->

                                      <!--begin::Toolbar-->
                                      <div class="dropzone-toolbar">
                                        <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                        <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                            class="bi bi-x fs-3"></i></span>
                                      </div>
                                      <!--end::Toolbar-->
                                    </div>
                                  </div>
                                  <!--end::Items-->
                                </div>
                                <!--end::Dropzone-->

                                <!--begin::Hint-->
                                <span class="form-text text-muted">Max file size is 1MB and max number of files is
                                  5.</span>
                                <!--end::Hint-->
                              </div>
                              <!--end::Col-->
                            </div>
                            <!--end::Input group-->
                          </form>
                          <!--end::Content-->
                        </div>
                        <!--end::Wrapper-->
                      </div>
                      <!--end::Notice-->
                      <!-- <div
                          v-if="!modalInfo.status"
                          class="symbol symbol-100px symbol-circle mb-7"
                        >
                          <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`"
                            alt="image"
                          />
                        </div> -->
                      <!--begin::Form-->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'imageInput'">
                      <!--begin::Form-->
                      <form class="form" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " action="#" method="post">
                        <!--begin::Hint-->
                        <div class="form-text">{{ field.hint }}</div>
                        <!--end::Hint-->
                        <!--begin::Input group-->
                        <div class="form-group row">
                          <!--begin::Col-->
                          <div class="col-lg-12">
                            <!--begin::Dropzone-->
                            <div class="dropzone dropzone-queue mb-3" id="kt_dropzonejs_example_2">
                              <!--begin::Controls-->
                              <div class="dropzone-panel mb-lg-0 mb-2">
                                <!--begin::Image input-->
                                <div class="d-flex justify-content-start ms-5">
                                  <div class="image-input image-input-outline" data-kt-image-input="true" style="
                                        background-image: url(assets/images/png/blank-profile.png);
                                      ">
                                    <!--begin::Preview existing avatar-->
                                    <div class="image-input-wrapper w-125px h-125px" :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath
                                      }/${info[field.name]});`"></div>
                                    <!--end::Preview existing avatar-->
                                    <!--begin::Label-->
                                    <label
                                      class="dropzone-select btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                      data-kt-image-input-action="change" data-bs-toggle="tooltip" title="تغییر آواتار">
                                      <i class="bi bi-pencil-fill fs-7"></i>
                                    </label>
                                    <!--end::Label-->
                                  </div>
                                </div>
                                <!--end::Image input-->
                                <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                <a class="dropzone-remove-all btn btn-sm btn-light-primary">حذف همه</a>
                              </div>
                              <!--end::Controls-->

                              <!--begin::Items-->
                              <div class="dropzone-items wm-200px">
                                <div class="dropzone-item" style="display: none">
                                  <!--begin::File-->
                                  <div class="dropzone-file">
                                    <div class="dropzone-filename" title="some_image_file_name.jpg">
                                      <span data-dz-name>some_image_file_name.jpg</span>
                                      <strong>(<span data-dz-size>340kb</span>)</strong>
                                    </div>

                                    <div class="dropzone-error" data-dz-errormessage></div>
                                  </div>
                                  <!--end::File-->

                                  <!--begin::Progress-->
                                  <div class="dropzone-progress">
                                    <div class="progress">
                                      <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                        aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                    </div>
                                  </div>
                                  <!--end::Progress-->

                                  <!--begin::Toolbar-->
                                  <div class="dropzone-toolbar">
                                    <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                    <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                        class="bi bi-x fs-3"></i></span>
                                    <span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span>
                                  </div>
                                  <!--end::Toolbar-->
                                </div>
                              </div>
                              <!--end::Items-->
                            </div>
                            <!--end::Dropzone-->

                            <!--begin::Hint-->
                            <span class="form-text text-muted ms-5">حداکثر حجم فایل انتخابی 1 مگابایت می‌باشد</span>
                            <!--end::Hint-->
                          </div>
                          <!--end::Col-->
                        </div>
                        <!--end::Input group-->
                      </form>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'textarea'" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                      ">
                      <editor v-model="field.value" :api-key="tinymceToken" :init="{
                        menubar: field.menubar,
                        plugins: field.plugins
                          ? field.plugins
                          : tinyMCE_Def.plugins,
                        directionality: field.directionality,
                        toolbar: field.toolbar
                          ? field.toolbar
                          : tinyMCE_Def.toolbar,
                        height: 200,
                      }" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'radioGroup'">
                      <div class="rounded border border-dashed p-10" :class="field.required && field.errorCode > 0
                        ? 'border-danger'
                        : ''
                        ">
                        <div v-for="(option, index) in field.options" :key="index" class="mb-5">
                          <div class="form-check">
                            <input class="form-check-input" :checked="option.value == field.value" type="radio"
                              @click="setRadioGroup(field, option.value, true)" :id="`radiogroup${index}`"
                              :name="field.name" />
                            <label class="form-check-label" :for="`radiogroup${index}`">{{ option.title }}</label>
                          </div>
                        </div>
                        <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                          class="invalid-feedback d-block">
                          {{ field.validation[field.errorCode - 1].error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(field, index) in contents.fields" :key="index" class="mb-10 d-flex flex-column">
                  <div v-if="field.showable">
                    <label v-if="field.title.length > 0 && index > 1" class="fs-5 fw-bolder form-label mb-2">
                      <span :class="field.required ? 'required' : ''">{{
                        field.title
                      }}</span>
                    </label>
                    <div :tabindex="index" v-if="field.type == 'text'">
                      <input :ref="`${field.name}_Input`" :minlength="field.minLength" :maxlength="field.maxLength"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                            ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        :type="field.type" :placeholder="`${field.placeholder}`" v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'number'">
                      <input :ref="`${field.name}_Input`" :min="field.min" :max="field.max" :step="field.steps"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                            ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        type="number" :placeholder="`${field.placeholder}`" v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'summary'">
                      <textarea :dir="inlineRouteLocale == 'fa' ? 'rtl' : 'ltr'" :ref="`${field.name}_Input`"
                        :placeholder="field.placeholder" v-model="info[field.name]" :id="field.name" :rows="field.rows"
                        class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " name="subject"></textarea>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'combobox'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true"
                        class="form-control form-control-solid p-5" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " :placeholder="field.placeholder" label="title" v-model="info[field.name]"
                        :searchable="true" :options="field.options">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :ref="field.name" :tabindex="index" v-else-if="field.type == 'multiselect'">
                      <div v-if="
                        info[field.name] &&
                        info[field.name].length &&
                        field.maxTags !== -1
                      " class="d-flex justify-content-end text-secondary">
                        {{ info[field.name].length }} / {{ field.maxTags }}
                      </div>
                      <div v-else-if="field.maxTags !== -1" class="d-flex justify-content-end text-secondary">
                        0 / {{ field.maxTags }}
                      </div>
                      <multiselect class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " v-model="info[field.name]" :placeholder="field.placeholder" mode="tags" :max="field.maxTags"
                        label="title" :close-on-select="false" :searchable="true" :options="field.options" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'file'">
                      <div v-if="!modalInfo.status" class="symbol symbol-100px symbol-circle mb-7">
                        <img :src="info[field.name]
                          ? `${backendHost}/uploads/${$store.state.uploadsPath
                          }/${info[field.name]}`
                          : `${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`
                          " alt="image" id="photoPreview" />
                      </div>
                      <div v-else id="photoPreview" class="d-none"></div>
                      <!--begin::Notice-->
                      <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                        <!--begin::Icon-->
                        <!--begin::Svg Icon | -->
                        <i class="bi bi-file-earmark-arrow-up text-primary fs-3x me-2"></i>
                        <!--end::Svg Icon-->
                        <!--end::Icon-->
                        <!--begin::Wrapper-->
                        <div class="d-flex flex-stack flex-grow-1">
                          <!--begin::Content-->
                          <form class="form" :class="field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                            " action="#" method="post">
                            <!--begin::Input group-->
                            <div class="form-group row">
                              <!--begin::Col-->
                              <div class="col-12">
                                <!--begin::Dropzone-->
                                <div class="dropzone dropzone-queue mb-2" id="kt_dropzonejs_example_2">
                                  <!--begin::Controls-->
                                  <div class="d-flex">
                                    <div class="dropzone-panel mb-lg-0 mb-2">
                                      <a class="dropzone-select btn btn-sm btn-primary me-2">الصاق فایل</a>
                                      <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                      <a class="dropzone-remove-all btn btn-sm btn-light-primary me-2">حذف همه</a>
                                    </div>
                                    <a class="dropzone-photo-delete btn btn-sm btn-danger"
                                      :class="modalInfo.status ? 'd-none' : ''"
                                      @click="deleteFilePhoto(field.name)">حذف</a>
                                  </div>
                                  <!--end::Controls-->

                                  <!--begin::Items-->
                                  <div class="dropzone-items d-flex flex-wrap w-100 gap-2">
                                    <div class="dropzone-item bg-light border border-primary border-dashed w-150px"
                                      style="display: none">
                                      <!--begin::File-->
                                      <div class="dropzone-file w-100 mt-5">
                                        <div class="image-input" data-kt-image-input="true">
                                          <div class="image-input-wrapper">
                                            <img data-dz-thumbnail="" class="dz-image" alt="" />
                                          </div>
                                          <!--begin::Edit button-->
                                          <label
                                            class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow dropzone-delete"
                                            data-dz-remove data-kt-image-input-action="change" data-bs-toggle="tooltip"
                                            data-bs-dismiss="click">
                                            <i class="bi bi-trash-fill fs-7"></i>
                                          </label>
                                          <!--end::Edit button-->
                                        </div>
                                        <div class="dropzone-filename d-flex" title="some_image_file_name.jpg">
                                          <div class="w-50 turncating">
                                            <span data-dz-name>some_image_file_name.jpg</span>
                                          </div>
                                          <strong class="W-50">(<span data-dz-size>340kb</span>)</strong>
                                        </div>
                                        <div class="dropzone-error" data-dz-errormessage></div>
                                      </div>
                                      <!--end::File-->

                                      <!--begin::Progress-->
                                      <div class="dropzone-progress">
                                        <div class="progress">
                                          <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                            aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                        </div>
                                      </div>
                                      <!--end::Progress-->

                                      <!--begin::Toolbar-->
                                      <div class="dropzone-toolbar">
                                        <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                        <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                            class="bi bi-x fs-3"></i></span>
                                      </div>
                                      <!--end::Toolbar-->
                                    </div>
                                  </div>
                                  <!--end::Items-->
                                </div>
                                <!--end::Dropzone-->

                                <!--begin::Hint-->
                                <span class="form-text text-muted">Max file size is 1MB and max number of files is
                                  5.</span>
                                <!--end::Hint-->
                              </div>
                              <!--end::Col-->
                            </div>
                            <!--end::Input group-->
                          </form>
                          <!--end::Content-->
                        </div>
                        <!--end::Wrapper-->
                      </div>
                      <!--end::Notice-->
                      <!-- <div
                          v-if="!modalInfo.status"
                          class="symbol symbol-100px symbol-circle mb-7"
                        >
                          <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`"
                            alt="image"
                          />
                        </div> -->
                      <!--begin::Form-->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'imageInput'">
                      <!--begin::Form-->
                      <form class="form" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " action="#" method="post">
                        <!--begin::Hint-->
                        <div class="form-text">{{ field.hint }}</div>
                        <!--end::Hint-->
                        <!--begin::Input group-->
                        <div class="form-group row">
                          <!--begin::Col-->
                          <div class="col-lg-12">
                            <!--begin::Dropzone-->
                            <div class="dropzone dropzone-queue mb-3" id="kt_dropzonejs_example_2">
                              <!--begin::Controls-->
                              <div class="dropzone-panel mb-lg-0 mb-2">
                                <!--begin::Image input-->
                                <div class="d-flex justify-content-start ms-5">
                                  <div class="image-input image-input-outline" data-kt-image-input="true" style="
                                        background-image: url(assets/images/png/blank-profile.png);
                                      ">
                                    <!--begin::Preview existing avatar-->
                                    <div class="image-input-wrapper w-125px h-125px" :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath
                                      }/${info[field.name]});`"></div>
                                    <!--end::Preview existing avatar-->
                                    <!--begin::Label-->
                                    <label
                                      class="dropzone-select btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                      data-kt-image-input-action="change" data-bs-toggle="tooltip" title="تغییر آواتار">
                                      <i class="bi bi-pencil-fill fs-7"></i>
                                    </label>
                                    <!--end::Label-->
                                  </div>
                                </div>
                                <!--end::Image input-->
                                <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                <a class="dropzone-remove-all btn btn-sm btn-light-primary">حذف همه</a>
                              </div>
                              <!--end::Controls-->

                              <!--begin::Items-->
                              <div class="dropzone-items wm-200px">
                                <div class="dropzone-item" style="display: none">
                                  <!--begin::File-->
                                  <div class="dropzone-file">
                                    <div class="dropzone-filename" title="some_image_file_name.jpg">
                                      <span data-dz-name>some_image_file_name.jpg</span>
                                      <strong>(<span data-dz-size>340kb</span>)</strong>
                                    </div>

                                    <div class="dropzone-error" data-dz-errormessage></div>
                                  </div>
                                  <!--end::File-->

                                  <!--begin::Progress-->
                                  <div class="dropzone-progress">
                                    <div class="progress">
                                      <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                        aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                    </div>
                                  </div>
                                  <!--end::Progress-->

                                  <!--begin::Toolbar-->
                                  <div class="dropzone-toolbar">
                                    <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                    <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                        class="bi bi-x fs-3"></i></span>
                                    <span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span>
                                  </div>
                                  <!--end::Toolbar-->
                                </div>
                              </div>
                              <!--end::Items-->
                            </div>
                            <!--end::Dropzone-->

                            <!--begin::Hint-->
                            <span class="form-text text-muted ms-5">حداکثر حجم فایل انتخابی 1 مگابایت می‌باشد</span>
                            <!--end::Hint-->
                          </div>
                          <!--end::Col-->
                        </div>
                        <!--end::Input group-->
                      </form>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'textarea'" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                      ">
                      <editor v-model="info[field.name]" :api-key="tinymceToken" :init="{
                        menubar: field.menubar,
                        plugins: field.plugins
                          ? field.plugins
                          : tinyMCE_Def.plugins,
                        directionality: field.directionality,
                        toolbar: field.toolbar
                          ? field.toolbar
                          : tinyMCE_Def.toolbar,
                        height: 200,
                      }" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'radioGroup'">
                      <div class="rounded border border-dashed p-10" :class="field.required && field.errorCode > 0
                        ? 'border-danger'
                        : ''
                        ">
                        <div v-for="(option, index) in field.options" :key="index" class="mb-5">
                          <div class="form-check">
                            <input class="form-check-input" :checked="option.value == info[field.name]" type="radio"
                              @click="setRadioGroup(field, option.value, true)" :id="`radiogroup${index}`"
                              :name="field.name" />
                            <label class="form-check-label" :for="`radiogroup${index}`">{{ option.title }}</label>
                          </div>
                        </div>
                        <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                          class="invalid-feedback d-block">
                          {{ field.validation[field.errorCode - 1].error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-content-center gap-5 mt-10">
                <button class="btn btn-primary" @click="closeModal('validate', info)">
                  Render
                </button>
                <!-- <button class="btn btn-primary" @click="closeModal('validate', info)">
                  Download the video with the logo
                </button>
                <button class="btn btn-outline-primary" @click="closeModal('validate', info)">
                  Download the video without logo and share it in website
                </button>
                <button class="btn btn-outline-primary" disabled>
                  Download the video without logo 5$
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="stepType && stepType == 'wizard'"
      class="modal-dialog modal-dialog-centered modal-sticky-lg modal-fullscreen">
      <div class="modal-content rounded">
        <div style="height: 10vh" class="modal-header border-gray-500 shadow-sm">
          <h2>{{ modalInfo.status ? 'Create' : 'Edit' }} offline package</h2>
          <div class="btn btn-icon btn-sm btn-active-icon-primary" @click="closeModal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                  fill="black" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
              </svg>
            </span>
          </div>
        </div>
        <div style="height: 80vh;" class="modal-body d-flex flex-row justify-content-between scroll-y">
          <div class="p-2 col-3 h-100 scroll-y" style="border-left: 1px solid #000;">
            <h3 class="p-2" style="border-bottom: 1px solid #000;">
              Table of contents
            </h3>
            <div class="py-2 px-3">
              <div v-for="(step, index) in hafezliNewObj.steps" :key="step">
                <fieldset class="mb-4" v-if="index > 0">
                  <legend class="d-flex flex-row justify-content-between align-items-center">
                    <h4 class="col-6 m-0">{{ step.title }} - {{ index }}</h4>
                    <div class="d-flex flex-row gap-1 justify-content-end col-6">
                      <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                        @click="addHafezliSteps_New(index)"></button>
                      <button v-if="index > 1" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                        @click="deleteHafezliSteps_New(index)"></button>
                    </div>
                  </legend>
                  <button v-for="session in step.sessions" :key="session" class="w-100 btn mb-4"
                    :class="hafezliNewObj.curStep == `${index}-${session.name}` ? 'btn-primary' : 'btn-secondary'"
                    @click="changeHafezliStep_New(`${index}-${session.name}`)">
                    {{ session.title }}
                  </button>
                </fieldset>
                <button v-else class="w-100 btn mb-2"
                  :class="hafezliNewObj.curStep == index ? 'btn-primary' : 'btn-secondary'"
                  @click="changeHafezliStep_New(index)">
                  {{ step.title }}
                </button>
              </div>
            </div>
          </div>
          <div class="h-100 col-9 px-7 d-flex flex-column justify-content-center align-items-center">
            <div v-if="hafezliNewObj.curStep.includes('lead')" class="w-100 scroll-y">
              <div class="mt-5 d-flex justify-content-between">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Lock status
                </label>
                <input class="form-check-input w-20px h-20px end alig ms-10" type="checkbox"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.lock" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Activity title
                </label>
                <input class="form-control form-control-solid p-4" type="text"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.title" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Summary of activity {{ hafezliCurStepIndex }}
                </label>
                <textarea class="form-control form-control-solid p-4" rows="2"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.summary"></textarea>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Description
                </label>
                <editor v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.description" :api-key="tinymceToken"
                  :init="{
                    menubar:
                      field && field.menubar
                        ? field.menubar
                        : tinyMCE_Def.menubar,
                    plugins:
                      field && field.plugins
                        ? field.plugins
                        : tinyMCE_Def.plugins,
                    directionality:
                      field && field.directionality
                        ? field.directionality
                        : tinyMCE_Def.directionality,
                    toolbar:
                      field && field.toolbar
                        ? field.toolbar
                        : tinyMCE_Def.toolbar,
                    height:
                      field && field.minHeight
                        ? field.minHeight
                        : tinyMCE_Def.minHeight,
                  }" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Upload photos \ videos \ voices
                </label>
                <div @click="
                  setModalConfigs('choose', {
                    root: 'files',
                    depth: 1,
                    child: 'lead',
                    index: hafezliCurStepIndex
                  })
                  " class="fv-row">
                  {{ hafezliNewObj.info[hafezliCurStepIndex].lead.files }}
                  <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                    id="kt_dropzonejs_example_1">
                    <div v-if="
                      hafezliNewObj.info[hafezliCurStepIndex].lead.files &&
                      hafezliNewObj.info[hafezliCurStepIndex].lead.files.length > 0
                    " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                      <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].lead.files" :key="photo"
                        class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                        <div class="symbol symbol-100px">
                          <!-- <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                          /> -->
                          <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                        </div>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[0]
                            : photo["filename"]
                              ? photo["filename"].split(".")[0]
                              : "???"
                        }}</label>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[1].toUpperCase()
                            : photo["filename"]
                              ? photo["filename"].split(".")[1].toUpperCase()
                              : "???"
                        }}</label>
                      </div>
                    </div>
                    <div v-else
                      class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                      <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                      <div class="ms-4">
                        <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                          Click to select your files
                        </h3>
                        <span class="fs-7 fw-bold text-gray-400">Max files: 10</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Quizes part
                </label>
                <div class="d-flex flex-center flex-column gap-3">
                  <fieldset class="w-100 mt-5" v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].lead.quizes"
                    :key="qi">
                    <legend class="d-flex flex-row justify-content-between align-items-center">
                      <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                      <div class="d-flex flex-row gap-1 justify-content-end col-6">
                        <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                          @click="addHafezliQuiz_New('lead', qi)"></button>
                        <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                          @click="deleteHafezliQuiz_New('lead', qi)"></button>
                      </div>
                    </legend>
                    <div>
                      <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                        menubar:
                          field && field.menubar
                            ? field.menubar
                            : tinyMCE_Def.menubar,
                        plugins:
                          field && field.plugins
                            ? field.plugins
                            : tinyMCE_Def.plugins,
                        directionality:
                          field && field.directionality
                            ? field.directionality
                            : tinyMCE_Def.directionality,
                        toolbar:
                          field && field.toolbar
                            ? field.toolbar
                            : tinyMCE_Def.toolbar,
                        height:
                          field && field.minHeight
                            ? field.minHeight
                            : tinyMCE_Def.minHeight,
                      }" />
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Tip of question {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['summary']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer type
                      </label>
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                        :options="hafezliNewObj.objects.quiz">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div v-if="q.type == 'clozeTest'">
                      Fill in answers as the order of blanks. In the user view the system will radomize it automatically.
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'blank'">
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'matching'">
                      <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                        v-for="(a, ai) in q['answer']" :key="ai">
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == 'shortAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == 'longAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == '2choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '3choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '4choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 3
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][3]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][3]" />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <!-- <div class="mt-5 d-flex justify-content-between">
                <label class="fs-5 fw-bolder form-label mb-2">
                  آیا زبان آموز باید پاسخی را ثبت کند؟
                </label>
                <input class="form-check-input w-20px h-20px end alig ms-10" type="checkbox"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.question" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
              <!-- <div v-if="hafezliNewObj.info[hafezliCurStepIndex].lead.question" class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  نوع پاسخ زبان‌آموز را انتخاب نمایید
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.ansType"
                  :options="hafezliNewObj.objects.general">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
            </div>
            <div v-else-if="hafezliNewObj.curStep.includes('tasks')" class="w-100 scroll-y">
              <fieldset class="mt-5" v-for="(t, ti) in hafezliNewObj.info[hafezliCurStepIndex].tasks" :key="ti">
                <legend class="d-flex flex-row justify-content-between align-items-center p-2 rounded"
                  :class="hafezliNewObj.curTask == ti ? 'bg-primary' : 'bg-secondary'">
                  <h4 class="col-6 m-0">Task - {{ ti + 1 }}</h4>
                  <div class="d-flex flex-row gap-1 justify-content-end col-6">
                    <button class="btn btn-dark btn-sm btn-icon" @click="collapseHafezliTask_New(ti)"
                      :class="hafezliNewObj.curTask == ti ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></button>
                    <button class="btn btn-success btn-sm btn-icon bi bi-plus" @click="addHafezliTask_New(ti)"></button>
                    <button v-if="ti > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                      @click="deleteHafezliTask_New(ti)"></button>
                  </div>
                </legend>
                <div :class="hafezliNewObj.curTask == ti ? 'd-block' : 'd-none'">
                  <div class="mt-5">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Description of Tasks
                    </label>
                    {{ field && field.minHeight
                      ? field.minHeight
                      : tinyMCE_Def.minHeight }}
                    <editor v-model="t['description']" :api-key="tinymceToken" :init="{
                      menubar:
                        field && field.menubar
                          ? field.menubar
                          : tinyMCE_Def.menubar,
                      plugins:
                        field && field.plugins
                          ? field.plugins
                          : tinyMCE_Def.plugins,
                      directionality:
                        field && field.directionality
                          ? field.directionality
                          : tinyMCE_Def.directionality,
                      toolbar:
                        field && field.toolbar
                          ? field.toolbar
                          : tinyMCE_Def.toolbar,
                      height: tinyMCE_Def.minHeight,
                    }" />
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                  <div class="mt-5">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Photos/ Videos / Audios
                    </label>
                    <div @click="
                      setModalConfigs('choose', {
                        root: 'files',
                        depth: 2,
                        child: 'tasks',
                        index: hafezliCurStepIndex,
                        childIndex: ti
                      })
                      " class="fv-row">
                      {{ hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files }}
                      <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                        id="kt_dropzonejs_example_1">
                        <div v-if="
                          hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files &&
                          hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files.length > 0
                        " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                          <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files" :key="photo"
                            class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                            <div class="symbol symbol-100px">
                              <!-- <img
                                :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                              /> -->
                              <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                            </div>
                            <label for="">{{
                              typeof photo == "string"
                                ? photo.split(".")[0]
                                : photo["filename"]
                                  ? photo["filename"].split(".")[0]
                                  : "???"
                            }}</label>
                            <label for="">{{
                              typeof photo == "string"
                                ? photo.split(".")[1].toUpperCase()
                                : photo["filename"]
                                  ? photo["filename"].split(".")[1].toUpperCase()
                                  : "???"
                            }}</label>
                          </div>
                        </div>
                        <div v-else
                          class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                          <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                          <div class="ms-4">
                            <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                            </h3>
                            <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                  <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Quizes
                    </label>
                    <div class="d-flex flex-center flex-column gap-3">
                      <fieldset class="w-100 mt-5"
                        v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].quizes" :key="qi">
                        <legend class="d-flex flex-row justify-content-between align-items-center">
                          <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                          <div class="d-flex flex-row gap-1 justify-content-end col-6">
                            <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                              @click="addHafezliQuiz_New(ti, qi)"></button>
                            <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                              @click="deleteHafezliQuiz_New(ti, qi)"></button>
                          </div>
                        </legend>
                        <div>
                          <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                            menubar:
                              field && field.menubar
                                ? field.menubar
                                : tinyMCE_Def.menubar,
                            plugins:
                              field && field.plugins
                                ? field.plugins
                                : tinyMCE_Def.plugins,
                            directionality:
                              field && field.directionality
                                ? field.directionality
                                : tinyMCE_Def.directionality,
                            toolbar:
                              field && field.toolbar
                                ? field.toolbar
                                : tinyMCE_Def.toolbar,
                            height:
                              field && field.minHeight
                                ? field.minHeight
                                : tinyMCE_Def.minHeight,
                          }" />
                        </div>
                        <div class="mt-5">
                          <label class="fs-5 fw-bolder form-label mb-2">
                            Tip {{ qi + 1 }}
                          </label>
                          <textarea class="form-control form-control-solid p-4" rows="2"
                            v-model="q['summary']"></textarea>
                          <div class="invalid-feedback d-none">متن خطا</div>
                        </div>
                        <div class="mt-5">
                          <label class="fs-5 fw-bolder form-label mb-2">
                            Answer type
                          </label>
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                            :options="hafezliNewObj.objects.quiz">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div class="invalid-feedback d-none">متن خطا</div>
                        </div>
                        <div v-if="q.type == 'clozeTest'">
                          Fill in answers as the order of blanks. In the user view the system will radomize it automatically.
                          <input v-for="(a, ai) in q['answer']" :key="ai"
                            class="form-control form-control-solid p-4 mt-2" type="text"
                            :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                        </div>
                        <div v-else-if="q.type == 'blank'">
                          <input v-for="(a, ai) in q['answer']" :key="ai"
                            class="form-control form-control-solid p-4 mt-2" type="text"
                            :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                        </div>
                        <div v-else-if="q.type == 'matching'">
                          <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                            v-for="(a, ai) in q['answer']" :key="ai">
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == 'shortAns'">
                          <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                            v-model="q['answer'][0]" />
                        </div>
                        <div v-else-if="q.type == 'longAns'">
                          <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                            v-model="q['answer'][0]" />
                        </div>
                        <div v-else-if="q.type == '2choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == '3choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 2
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][2]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][2]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == '4choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 2
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][2]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 3
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][3]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][2]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][3]" />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div v-else-if="hafezliNewObj.curStep.includes('followUp')" class="w-100 scroll-y">
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Description of follow up
                </label>
                <editor v-model="hafezliNewObj.info[hafezliCurStepIndex].followUp.description" :api-key="tinymceToken"
                  :init="{
                    menubar:
                      field && field.menubar
                        ? field.menubar
                        : tinyMCE_Def.menubar,
                    plugins:
                      field && field.plugins
                        ? field.plugins
                        : tinyMCE_Def.plugins,
                    directionality:
                      field && field.directionality
                        ? field.directionality
                        : tinyMCE_Def.directionality,
                    toolbar:
                      field && field.toolbar
                        ? field.toolbar
                        : tinyMCE_Def.toolbar,
                    height:
                      field && field.minHeight
                        ? field.minHeight
                        : tinyMCE_Def.minHeight,
                  }" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Uploads the files
                </label>
                <div @click="
                  setModalConfigs('choose', {
                    root: 'files',
                    depth: 1,
                    child: 'followUp',
                    index: hafezliCurStepIndex
                  })
                  " class="fv-row">
                  {{ hafezliNewObj.info[hafezliCurStepIndex].followUp.files }}
                  <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                    id="kt_dropzonejs_example_1">
                    <div v-if="
                      hafezliNewObj.info[hafezliCurStepIndex].followUp.files &&
                      hafezliNewObj.info[hafezliCurStepIndex].followUp.files.length > 0
                    " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                      <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].followUp.files" :key="photo"
                        class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                        <div class="symbol symbol-100px">
                          <!-- <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                          /> -->
                          <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                        </div>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[0]
                            : photo["filename"]
                              ? photo["filename"].split(".")[0]
                              : "???"
                        }}</label>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[1].toUpperCase()
                            : photo["filename"]
                              ? photo["filename"].split(".")[1].toUpperCase()
                              : "???"
                        }}</label>
                      </div>
                    </div>
                    <div v-else
                      class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                      <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                      <div class="ms-4">
                        <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                        </h3>
                        <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Quizes
                </label>
                <div class="d-flex flex-center flex-column gap-3">
                  <fieldset class="w-100 mt-5"
                    v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].followUp.quizes" :key="qi">
                    <legend class="d-flex flex-row justify-content-between align-items-center">
                      <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                      <div class="d-flex flex-row gap-1 justify-content-end col-6">
                        <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                          @click="addHafezliQuiz_New('followUp', qi)"></button>
                        <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                          @click="deleteHafezliQuiz_New('followUp', qi)"></button>
                      </div>
                    </legend>
                    <div>
                      <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                        menubar:
                          field && field.menubar
                            ? field.menubar
                            : tinyMCE_Def.menubar,
                        plugins:
                          field && field.plugins
                            ? field.plugins
                            : tinyMCE_Def.plugins,
                        directionality:
                          field && field.directionality
                            ? field.directionality
                            : tinyMCE_Def.directionality,
                        toolbar:
                          field && field.toolbar
                            ? field.toolbar
                            : tinyMCE_Def.toolbar,
                        height:
                          field && field.minHeight
                            ? field.minHeight
                            : tinyMCE_Def.minHeight,
                      }" />
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Tip {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['summary']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer type
                      </label>
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                        :options="hafezliNewObj.objects.quiz">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div v-if="q.type == 'clozeTest'">
                      Put answers in correct order, the system will change the order.
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'blank'">
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'matching'">
                      <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                        v-for="(a, ai) in q['answer']" :key="ai">
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == 'shortAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == 'longAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == '2choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '3choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '4choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 3
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][3]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][3]" />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <!-- <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  نوع پاسخ زبان‌آموز را انتخاب نمایید
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].followUp.ansType"
                  :options="hafezliNewObj.objects.general">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
            </div>
            <div v-else class="w-100 scroll-y">
              <h3 class="d-none mb-20 text-center">The general information about the package</h3>
              <div class="mt-2">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Photo \ Video for the banner
                </label>
                <div @click="
                  setModalConfigs('choose', {
                    root: 'files',
                    depth: 0,
                    index: 0
                  })
                  " class="fv-row">
                  {{ hafezliNewObj.info[Number(hafezliNewObj.curStep)].files }}
                  <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                    id="kt_dropzonejs_example_1">
                    <div v-if="
                      hafezliNewObj.info[Number(hafezliNewObj.curStep)].files &&
                      hafezliNewObj.info[Number(hafezliNewObj.curStep)].files.length > 0
                    " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                      <div v-for="photo in hafezliNewObj.info[Number(hafezliNewObj.curStep)].files" :key="photo"
                        class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                        <div class="symbol symbol-100px">
                          <!-- <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                          /> -->
                          <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                        </div>
                        <label for="">{{
                          typeof photo == "string" && photo.split(".") && photo.split(".")[0]
                            ? photo.split(".")[0]
                            : photo["filename"]
                              ? photo["filename"].split(".")[0]
                              : "???"
                        }}</label>
                        <label for="">{{
                          typeof photo == "string" && photo.split(".") && photo.split(".")[1]
                            ? photo.split(".")[1].toUpperCase()
                            : photo["filename"]
                              ? photo["filename"].split(".")[1].toUpperCase()
                              : "???"
                        }}</label>
                      </div>
                    </div>
                    <div v-else
                      class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                      <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                      <div class="ms-4">
                        <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                          Click to select your files
                        </h3>
                        <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Title
                </label>
                <input class="form-control form-control-solid p-4" type="text" v-model="hafezliNewObj.info[0].title" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Summary
                </label>
                <textarea class="form-control form-control-solid p-4" rows="2"
                  v-model="hafezliNewObj.info[0].summary"></textarea>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Price (IRT)
                </label>
                <input class="form-control form-control-solid p-4" type="number"
                  v-model="hafezliNewObj.info[0].price" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Level
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[0].category" :options="hafezliNewObj['categories']">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Language
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[0].category" :options="hafezliNewObj['categories']">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Tags
                </label>
                <multiselect mode="tags" :close-on-select="false" :canDeselect="false" :hideSelected="true"
                  :searchable="true" class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[0].tags" :options="hafezliNewObj['tags']">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Description
                </label>
                <editor :api-key="tinymceToken" v-model="hafezliNewObj.info[0].description" :init="{
                  menubar: true,
                  plugins:
                    'wordcount searchreplace autolink table lists link emoticons directionality image',
                  directionality: editorDirection,
                  toolbar:
                    'styleselect image searchreplace | bold italic | alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist | link emoticons',
                  height: 200,
                }" />
              </div>
            </div>
          </div>
        </div>
        <div style="height: 10vh" class="modal-footer d-flex justify-content-center border-gray-500 shadow-lg">
          <button type="submit" class="btn btn-sm btn-success" @click="createHafezliProduct_New">
            Save draft
          </button>
          <button type="submit" class="btn btn-sm btn-danger" @click="closeModal">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <div v-else class="modal-dialog modal-dialog-centered" :class="contents.size">
      <div class="modal-content rounded">
        <div class="modal-header border-gray-300 shadow-sm">
          <h2 class="fw-bolder">
            {{ modalInfo.status ? contents.createTitle : contents.updateTitle }}
            {{ contents.title }}
          </h2>
          <!--begin::Description-->
          <!-- <div class="text-gray-400 fw-bold fs-5">
            {{ contents.subTitle.length ? contents.subTitle : "" }}
            <a href="#" class="fw-bolder link-primary">{{
              contents.subTitleLink.length ? contents.subTitleLink : ""
            }}</a>
          </div> -->
          <!--end::Description-->
          <div class="btn btn-icon btn-sm btn-active-icon-primary" @click="closeModal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                  fill="black" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
              </svg>
            </span>
          </div>
        </div>
        <div class="modal-body scroll-y mx-lg-5 my-7" :class="contents.size != 'modal-fullscreen' || !contents.size
          ? 'mh-50vh'
          : ''
          ">
          <div v-if="generalStep == 0">
            <div v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47'">
              <div>
                <h3>
                  {{ contents.fields[0].title }}
                </h3>
                <div class="d-flex flex-row justify-content-between">
                  <div class="mt-20 mt-md-0 col-12 col-md-5 d-flex row-cols-auto gap-5 gap-lg-10 flex-wrap"
                    data-kt-buttons="true">
                    <!--begin::Radio button-->
                    <label v-for="(option, index) in contents.fields[0].options" :key="index"
                      :class="index == 0 ? 'active' : ''"
                      class="col-12 btn btn-outline btn-outline-dashed d-flex flex-column text-start p-6">
                      <div class="d-flex flex-row align-items-center me-2">
                        <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                          <input class="form-check-input" type="radio" name="plan"
                            @click="setSelectedUpload(option.value, option)" />
                        </div>
                        <h4 class="">
                          {{ option.title }}
                        </h4>
                      </div>
                      <div class="w-100 mt-5 w-100 text-center">
                        <img v-if="option.uploadsPath"
                          :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${option.parse}`"
                          class="mh-150px mw-150px rounded" style="object-fit: cover" alt="" />
                        <img v-else :src="`${backendHost}/images/preview/${option.parse}`"
                          class="mh-150px mw-150px rounded" style="object-fit: cover" alt="" />
                      </div>
                      <div class="mt-10 d-flex flex-row justify-content-between align-items-center px-3">
                        <span class="fs-1 text-primary">{{ option.info.price }}</span>
                        <span>EUR</span>
                      </div>
                    </label>
                    <!--end::Radio button-->
                  </div>
                  <div
                    class="mb-20 mb-md-0 position-fixed position-md-relative bg-secondary start-0 end-0 top-0 col-12 col-md-6 d-md-flex flex-column p-10 border border-dashed border-secondary rounded">
                    <div class="d-flex flex-column" v-if="templateOption.status">
                      <h4>Template Description</h4>
                      <div class="d-flex flex-row flex-wrap mt-5">
                        <h5 class="fw-light">{{ templateOption.info.category }}</h5>
                        <span class="mx-2">-</span>
                        <h6 class="fw-light" v-for="(tag, index) in templateOption.info.tags" :key="tag">
                          {{ tag.tagName }}
                          <span v-if="index > 0" class="mx-2">-</span>
                        </h6>
                      </div>
                      <h5 class="fw-light mt-5">
                        {{ templateOption.info.summary }}
                      </h5>
                      <div class="mt-5" v-html="templateOption.info.description"></div>
                      <button class="btn btn-primary" @click="() => { templateOption.status = false }">Close</button>
                    </div>
                    <div v-else>
                      No template info to be displayed!
                    </div>
                  </div>
                </div>
                <div v-if="contents.fields[0].required && contents.fields[0].errorCode > 0" id="validationErrorFeedback"
                  class="invalid-feedback d-block">
                  {{ field.validation[field.errorCode - 1].error }}
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="generalStep == 1">
            <div dir="ltr" v-if="info['mode'] && info['mode'] == 'view'">
              <h6 class="p-2 mb-5" style="border-bottom: 1px solid">
                Date: {{ info.emailDate }}
              </h6>
              <h5 class="p-2 mb-5" style="border-bottom: 1px solid">
                From: {{ info.emailSender.toString() }}
              </h5>
              <h4 class="p-2 mb-5" style="border-bottom: 1px solid">
                Subject: {{ info.emailSubject.toString() }}
              </h4>
              <div class="p-5" v-html="info.emailDescription"></div>
            </div>
            <form v-else-if="displayStatus" id="kt_modal_add_role_form" class="form" action="#">
              <!--begin::Scroll-->
              <div class="d-flex flex-column scroll-y me-n7 pe-7" id="kt_modal_add_role_scroll" data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_add_role_header"
                data-kt-scroll-wrappers="#kt_modal_add_role_scroll" data-kt-scroll-offset="300px">
                <!--begin::Input group-->
                <div v-for="(field, index) in contents.fields ||
                  contents.elements[0].fields" :key="index" class="fv-row mb-10">
                  <div v-if="
                    (!modalInfo.status && field.editable) ||
                    (field.creatable != undefined
                      ? field.creatable && modalInfo.status
                      : modalInfo.status)
                  ">
                    <div :ref="field.name" v-if="
                      field.type !== 'card' &&
                      field.type !== 'email' &&
                      field.type !== 'ticket'
                    " class="d-flex justify-content-between">
                      <label v-if="field.title.length > 0" class="fs-5 fw-bolder form-label mb-2">
                        <span :class="field.required ? 'required' : ''">{{
                          field.title
                        }}</span>
                      </label>
                      <div v-if="
                        info[field.name] &&
                        info[field.name].length &&
                        field.maxLength &&
                        field.maxLength !== -1
                      " class="d-flex justify-content-end text-secondary">
                        {{ info[field.name].length }} / {{ field.maxLength }}
                      </div>
                      <div v-else-if="field.maxTags && field.maxTags !== -1"
                        class="d-flex justify-content-end text-secondary">
                        0 / {{ field.maxLength }}
                      </div>
                    </div>
                    <div :tabindex="index" v-if="field.type == 'text'">
                      <input :ref="`${field.name}_Input`" :minlength="field.minLength" :maxlength="field.maxLength"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                          ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        :type="field.type" :placeholder="`${field.placeholder}`" v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'number'">
                      <input :ref="`${field.name}_Input`" :min="field.min" :max="field.max" :step="field.steps"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                          ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        type="number" :placeholder="`${field.placeholder}`" v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'summary'">
                      <textarea :dir="inlineRouteLocale == 'fa' ? 'rtl' : 'ltr'" :ref="`${field.name}_Input`"
                        :placeholder="field.placeholder" v-model="info[field.name]" :id="field.name" :rows="field.rows"
                        class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " name="subject"></textarea>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'json'">
                      <json-editor-vue :id="field.name" :ref="`${field.name}_Input`" class="editor" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-if="field.type == 'units'">
                      <div>
                        <div class="py-5 d-flex flex-row align-items-center">
                          <input id="searchInput" class="col me-1 form-control form-control-solid p-4" type="search" placeholder="Filename or file type..." v-model="sfq" />
                          <button type="button" class="btn btn-primary btn-icon btn-sm p-4" @click="searchFiles">
                            <i class="bi bi-search"></i>
                          </button>
                        </div>
                        <div class="fv-row mb-8">
                          <!--begin::Label-->
                          <!-- <label class="d-flex align-items-center fs-6 fw-bold mb-8">
                            <span class="required">Lessons</span>
                            <i class="bi bi-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                              title="Choose a image"></i>
                          </label> -->
                          <!--end::Label-->
                          <!--begin::Radio group-->
                          <div class="d-flex flex-center flex-wrap" data-kt-buttons="true">
                            <!--begin::Radio button-->
                            <label v-for="(item, index) in hafezliUnits" :key="index" :id="`uploadImage_${item.formName}`"
                              class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-center text-start col-8 col-sm-6 col-md-5 col-lg-3 m-3">
                              <!--end::Description-->
                              <div class="d-flex align-items-center me-2">
                                <!--begin::Radio-->
                                <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                                  <input v-if="mode == 'multi'" class="form-check-input" type="checkbox" name="plan"
                                    :checked="typeof info[field.name] != 'string' && info[field.name].indexOf(item.formName) > -1" @click="
                                      setMultiSelectedUpload($event, item.formName, field.name)
                                      " />
                                  <input v-else class="form-check-input" type="radio" name="plan"
                                    :checked="info[field.name].indexOf(item.formName) > -1" @click="setMultiSelectedUpload($event, item.formName, field.name)" />
                                </div>
                                <!--end::Radio-->

                                <!--begin::Info-->
                                <div class="d-flex flex-column flex-center">
                                  <!-- <div class="col-12 bg-dark bg-opacity-5 d-flex flex-center rounded h-100px w-100px">
                            <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${image.productPhotos[0]}`"
                              class="mh-100 w-100 rounded" style="object-fit: cover" alt="" />
                          </div> -->
                                  <div class="d-flex flex-center flex-column col-12">
                                    <label class="col-12 text-center" for="">{{
                                      item.formName
                                      }}</label>
                                  </div>
                                </div>
                                <!--end::Info-->
                              </div>
                              <!--end::Description-->
                            </label>
                            <!--end::Radio button-->
                          </div>
                          <!--end::Radio group-->
                        </div>
                      </div>
                      <!-- <input :ref="`${field.name}_Input`" :minlength="field.minLength" :maxlength="field.maxLength"
                        class="form-control form-control-solid p-4" :class="`${field.class}
                          ${field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                          }`" :disabled="field.disabled ? true : false" aria-describedby="validationErrorFeedback"
                        :type="field.type" :placeholder="`${field.placeholder} 111`" v-model="info[field.name]" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div> -->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'code'">
                      <textarea dir="ltr" :ref="`${field.name}_Input`" :placeholder="field.placeholder"
                        v-model="info[field.name]" :id="field.name" :rows="field.rows"
                        class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " name="subject"></textarea>
                      <div dir="ltr" class="mt-2 p-5 rounded border-dashed border-primary" v-html="info[field.name]">
                      </div>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'elements'"
                      class="border border-1 border-dashed border-primary p-10">
                      <div class="text-center fs-2 fw-bold" v-if="info[field.name].length == 0">
                        No element has been selected
                      </div>
                      <div v-else>
                        <div v-for="(el, eli) in info[field.name]" :key="eli"
                          class="p-2 d-flex flex-column flex-lg-row justify-content-between align-items-center border border-1 border-dotted border-secondary mb-2">
                          <div class="col-12 col-lg-8 text-center text-lg-start py-5 py-lg-0">
                            {{ el.name }} -
                            {{
                              el.json &&
                                el.json.name &&
                                el.json.name.value &&
                                el.json.name.value.length > 0
                                ? el.json.name.value
                                : "نامشخص"
                            }}
                          </div>
                          <div
                            class="border-top border-top-1 border-secondary border-top-lg-0 col-12 col-lg-4 d-flex flex-row justify-content-center align-items-center mt-2 mt-lg-0">
                            <div class="col p-3">
                              <input type="checkbox" class="form-check-input w-20px h-20px"
                                @click="addGroupItem($event, el, eli)" />
                            </div>
                            <div class="col p-3">
                              <button type="button" class="btn btn-icon btn-secondary"
                                @click="setModalConfigs('elementSettings', eli)">
                                <i class="p-0 m-0 fs-6 fw-boldest bi bi-gear"></i>
                              </button>
                            </div>
                            <div class="col p-3">
                              <button type="button" class="btn btn-icon btn-light-primary">
                                <i class="p-0 m-0 fs-6 fw-boldest bi bi-pencil"></i>
                              </button>
                            </div>
                            <div class="col p-3">
                              <button type="button" class="btn btn-icon btn-light-danger">
                                <i class="p-0 m-0 fs-6 fw-boldest bi bi-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-center flex-column">
                        <button v-if="groupItems.length > 1" type="button" class="btn btn-secondary w-75 mt-5"
                          @click="groupingItems()">
                          Group selected elements
                          <i class="ms-2 fs-1 fw-boldest bi bi-plus-circle"></i>
                        </button>
                        <button type="button" class="btn btn-success w-50 mt-5"
                          @click="setModalConfigs('elements', { id: 0 })">
                          Add new element
                          <i class="ms-2 fs-1 fw-boldest bi bi-plus-circle"></i>
                        </button>
                      </div>
                      <!-- <textarea
                        dir="ltr"
                        v-model="info[field.name]"
                        :ref="`${field.name}_Input`"
                        :placeholder="field.placeholder"
                        :id="field.name"
                        :rows="field.rows"
                        class="form-control form-control-solid"
                        :class="
                          field.required && field.errorCode ? 'wrong-inputs' : ''
                        "
                        name="subject"
                      >
                      </textarea> -->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'formInputs'"
                      class="border border-1 border-dashed border-primary p-10">
                      <div v-if="info[field.name].length == 0" class="text-center fs-2 fw-bold">
                        No input has been selected
                      </div>
                      <div v-else>
                        <div v-for="el in info[field.name]" :key="el"
                          class="d-flex flex-column flex-lg-row justify-content-between align-items-center align-items-lg-start border border-1 border-dotted border-secondary mb-2">
                          <div class="col-12 col-lg-8 p-3 d-flex flex-column">
                            <div>
                              <label class="fs-5 fw-bolder form-label mb-2">
                                <span :class="el.required ? 'required' : ''">
                                  {{ el.label }}
                                </span>
                              </label>
                              <div v-if="el.type == 'text'">
                                <textarea disabled v-if="el.ui == 'textarea'"
                                  class="form-control form-control-solid p-4" rows="10"
                                  :placeholder="el.placeholder"></textarea>
                                <input disabled v-else class="form-control form-control-solid p-4" :type="el.type"
                                  :placeholder="el.placeholder" />
                              </div>
                              <div v-else-if="el.type == 'select'"></div>
                              <div v-else-if="el.type == 'file'"></div>
                            </div>
                            <div class="border border-light border-1 mt-5 p-5 rounded" v-if="el.editMode">
                              <div>
                                <div v-for="config in formInputsConfig['general']" :key="config">
                                  <label class="fs-5 fw-bolder form-label mb-2 mt-5">
                                    <span :class="el.required ? 'required' : ''">
                                      Write down the "{{ config.name }}" of the
                                      input
                                    </span>
                                  </label>
                                  <div>
                                    <textarea v-if="config.type == 'summary'"
                                      class="form-control form-control-solid p-4" rows="10"
                                      v-model="el[config.name]"></textarea>
                                    <input v-else class="form-control form-control-solid p-4" type="text"
                                      v-model="el[config.name]" />
                                  </div>
                                </div>
                                <div v-for="config in formInputsConfig[el.type]" :key="config">
                                  <div v-if="
                                    (config.vif &&
                                      el.required &&
                                      el.valiation.indexOf(config.vif) > -1) ||
                                    !config.vif
                                  ">
                                    <label class="fs-5 fw-bolder form-label mb-2 mt-5">
                                      <span :class="el.required ? 'required' : ''">
                                        Write down the "{{ config.name }}" of the
                                        input
                                      </span>
                                    </label>
                                    <div>
                                      <textarea v-if="config.type == 'summary'"
                                        class="form-control form-control-solid p-4" rows="10"
                                        v-model="el[config.name]"></textarea>
                                      <input v-else-if="config.type == 'text'"
                                        class="form-control form-control-solid p-4" type="text"
                                        v-model="el[config.name]" />
                                      <multiselect v-else-if="config.type == 'combobox'" mode="single"
                                        :canDeselect="false" :hideSelected="true" @click="setOfset(field)"
                                        class="form-control form-control-solid p-5" label="label"
                                        v-model="el[config.name]" :searchable="true" :options="config.options">
                                        <template v-slot:option="{ option }">
                                          {{ option.label }}
                                        </template>
                                      </multiselect>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-lg-3">
                            <div class="d-flex flex-row justify-content-center justify-content-lg-between p-3 gap-2">
                              <button type="button" class="d-flex flex-center p-3 col-5 btn btn-light-dark"
                                style="width: min-content" @click="inlineEditConfigs(el)">
                                <i class="p-0 m-0 fs-6 fw-boldest" :class="el.editMode ? 'bi bi-x' : 'bi bi-gear'"></i>
                              </button>
                              <button type="button" class="d-flex flex-center p-3 col-5 btn btn-light-primary"
                                style="width: min-content">
                                <i class="p-0 m-0 fs-6 fw-boldest bi bi-pencil"></i>
                              </button>
                              <button type="button" class="d-flex flex-center p-3 col-5 btn btn-light-danger"
                                style="width: min-content">
                                <i class="p-0 m-0 fs-6 fw-boldest bi bi-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-center">
                        <button type="button" class="btn btn-success w-75 mt-5"
                          @click="setModalConfigs('elements', { id: 0 })">
                          Add new input
                          <i class="ms-2 fs-1 fw-boldest bi bi-plus-circle"></i>
                        </button>
                      </div>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'combobox'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" @click="setOfset(field)"
                        class="form-control form-control-solid p-5" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                          " :placeholder="field.placeholder" label="title" v-model="info[field.name]"
                        :searchable="true" :options="field.options">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'template'"
                      :class="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' ? 'd-none' : ''">
                      <!--begin::Radio group-->
                      <div class="d-flex row-cols-auto gap-5 gap-lg-10 flex-wrap" data-kt-buttons="true">
                        <!--begin::Radio button-->
                        <label v-for="(option, index) in field.options" :key="index" :class="index == 0 ? 'active' : ''"
                          class="btn btn-outline btn-outline-dashed d-flex text-start p-6">
                          <!--end::Description-->
                          <div class="d-flex align-items-center me-2">
                            <!--begin::Radio-->
                            <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                              <input class="form-check-input" type="radio" name="plan"
                                @click="setSelectedUpload(option.value)" />
                            </div>
                            <!--end::Radio-->

                            <!--begin::Info-->
                            <div class="">
                              <img v-if="option.uploadsPath"
                                :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${option.parse}`"
                                class="h-75px w-100px rounded" style="object-fit: cover" alt="" />
                              <img v-else :src="`${backendHost}/images/preview/${option.parse}`"
                                class="h-75px w-100px rounded" style="object-fit: cover" alt="" />
                            </div>
                            <!--end::Info-->
                          </div>
                          <!--end::Description-->
                        </label>
                        <!--end::Radio button-->
                      </div>
                      <!--end::Radio group-->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :ref="field.name" :tabindex="index" v-else-if="field.type == 'multiselect'">
                      <div v-if="
                        info[field.name] &&
                        info[field.name].length &&
                        field.maxTags !== -1
                      " class="d-flex justify-content-end text-secondary">
                        {{ info[field.name].length }} / {{ field.maxTags }}
                      </div>
                      <div v-else-if="field.maxTags !== -1" class="d-flex justify-content-end text-secondary">
                        0 / {{ field.maxTags }}
                      </div>
                      <multiselect class="form-control form-control-solid" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " v-model="info[field.name]" :placeholder="field.placeholder" mode="tags" :max="field.maxTags"
                        label="title" :close-on-select="false" :searchable="true" :options="field.options" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'file'">
                      <div v-if="!modalInfo.status" class="symbol symbol-100px symbol-circle mb-7">
                        <img :src="info[field.name]
                          ? `${backendHost}/uploads/${$store.state.uploadsPath
                          }/${info[field.name]}`
                          : `${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`
                          " alt="image" id="photoPreview" />
                      </div>
                      <div v-else id="photoPreview" class="d-none"></div>
                      <!--begin::Notice-->
                      <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6">
                        <!--begin::Icon-->
                        <!--begin::Svg Icon | -->
                        <i class="bi bi-file-earmark-arrow-up text-primary fs-3x me-2"></i>
                        <!--end::Svg Icon-->
                        <!--end::Icon-->
                        <!--begin::Wrapper-->
                        <div class="d-flex flex-stack flex-grow-1">
                          <!--begin::Content-->
                          <form class="form" :class="field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                            " action="#" method="post">
                            <!--begin::Input group-->
                            <div class="form-group row">
                              <!--begin::Col-->
                              <div class="col-12">
                                <!--begin::Dropzone-->
                                <div class="dropzone dropzone-queue mb-2" id="kt_dropzonejs_example_2">
                                  <!--begin::Controls-->
                                  <div class="d-flex">
                                    <div class="dropzone-panel mb-lg-0 mb-2">
                                      <a class="dropzone-select btn btn-sm btn-primary me-2">الصاق فایل</a>
                                      <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                      <a class="dropzone-remove-all btn btn-sm btn-light-primary me-2">حذف همه</a>
                                    </div>
                                    <a class="dropzone-photo-delete btn btn-sm btn-danger"
                                      :class="modalInfo.status ? 'd-none' : ''"
                                      @click="deleteFilePhoto(field.name)">حذف</a>
                                  </div>
                                  <!--end::Controls-->

                                  <!--begin::Items-->
                                  <div class="dropzone-items d-flex flex-wrap w-100 gap-2">
                                    <div class="dropzone-item bg-light border border-primary border-dashed w-150px"
                                      style="display: none">
                                      <!--begin::File-->
                                      <div class="dropzone-file w-100 mt-5">
                                        <div class="image-input" data-kt-image-input="true">
                                          <div class="image-input-wrapper">
                                            <img data-dz-thumbnail="" class="dz-image" alt="" />
                                          </div>
                                          <!--begin::Edit button-->
                                          <label
                                            class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow dropzone-delete"
                                            data-dz-remove data-kt-image-input-action="change" data-bs-toggle="tooltip"
                                            data-bs-dismiss="click">
                                            <i class="bi bi-trash-fill fs-7"></i>
                                          </label>
                                          <!--end::Edit button-->
                                        </div>
                                        <div class="dropzone-filename d-flex" title="some_image_file_name.jpg">
                                          <div class="w-50 turncating">
                                            <span data-dz-name>some_image_file_name.jpg</span>
                                          </div>
                                          <strong class="W-50">(<span data-dz-size>340kb</span>)</strong>
                                        </div>
                                        <div class="dropzone-error" data-dz-errormessage></div>
                                      </div>
                                      <!--end::File-->

                                      <!--begin::Progress-->
                                      <div class="dropzone-progress">
                                        <div class="progress">
                                          <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                            aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                        </div>
                                      </div>
                                      <!--end::Progress-->

                                      <!--begin::Toolbar-->
                                      <div class="dropzone-toolbar">
                                        <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                        <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                            class="bi bi-x fs-3"></i></span>
                                      </div>
                                      <!--end::Toolbar-->
                                    </div>
                                  </div>
                                  <!--end::Items-->
                                </div>
                                <!--end::Dropzone-->

                                <!--begin::Hint-->
                                <span class="form-text text-muted">Max file size is 1MB and max number of files is
                                  5.</span>
                                <!--end::Hint-->
                              </div>
                              <!--end::Col-->
                            </div>
                            <!--end::Input group-->
                          </form>
                          <!--end::Content-->
                        </div>
                        <!--end::Wrapper-->
                      </div>
                      <!--end::Notice-->
                      <!-- <div
                        v-if="!modalInfo.status"
                        class="symbol symbol-100px symbol-circle mb-7"
                      >
                        <img
                          :src="`${backendHost}/uploads/${$store.state.uploadsPath}/1616284800000_Avatar.png`"
                          alt="image"
                        />
                      </div> -->
                      <!--begin::Form-->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'imageInput'">
                      <!--begin::Form-->
                      <form class="form" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                        " action="#" method="post">
                        <!--begin::Hint-->
                        <div class="form-text">{{ field.hint }}</div>
                        <!--end::Hint-->
                        <!--begin::Input group-->
                        <div class="form-group row">
                          <!--begin::Col-->
                          <div class="col-lg-12">
                            <!--begin::Dropzone-->
                            <div class="dropzone dropzone-queue mb-3" id="kt_dropzonejs_example_2">
                              <!--begin::Controls-->
                              <div class="dropzone-panel mb-lg-0 mb-2">
                                <!--begin::Image input-->
                                <div class="d-flex justify-content-start ms-5">
                                  <div class="image-input image-input-outline" data-kt-image-input="true" style="
                                      background-image: url(assets/images/png/blank-profile.png);
                                    ">
                                    <!--begin::Preview existing avatar-->
                                    <div class="image-input-wrapper w-125px h-125px" :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath
                                      }/${info[field.name]});`"></div>
                                    <!--end::Preview existing avatar-->
                                    <!--begin::Label-->
                                    <label
                                      class="dropzone-select btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                      data-kt-image-input-action="change" data-bs-toggle="tooltip" title="تغییر آواتار">
                                      <i class="bi bi-pencil-fill fs-7"></i>
                                    </label>
                                    <!--end::Label-->
                                  </div>
                                </div>
                                <!--end::Image input-->
                                <a class="dropzone-upload btn btn-sm btn-light-primary me-2">بارگذاری همه</a>
                                <a class="dropzone-remove-all btn btn-sm btn-light-primary">حذف همه</a>
                              </div>
                              <!--end::Controls-->

                              <!--begin::Items-->
                              <div class="dropzone-items wm-200px">
                                <div class="dropzone-item" style="display: none">
                                  <!--begin::File-->
                                  <div class="dropzone-file">
                                    <div class="dropzone-filename" title="some_image_file_name.jpg">
                                      <span data-dz-name>some_image_file_name.jpg</span>
                                      <strong>(<span data-dz-size>340kb</span>)</strong>
                                    </div>

                                    <div class="dropzone-error" data-dz-errormessage></div>
                                  </div>
                                  <!--end::File-->

                                  <!--begin::Progress-->
                                  <div class="dropzone-progress">
                                    <div class="progress">
                                      <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0"
                                        aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div>
                                    </div>
                                  </div>
                                  <!--end::Progress-->

                                  <!--begin::Toolbar-->
                                  <div class="dropzone-toolbar">
                                    <span class="dropzone-start"><i class="bi bi-play-fill fs-3"></i></span>
                                    <span class="dropzone-cancel" data-dz-remove style="display: none"><i
                                        class="bi bi-x fs-3"></i></span>
                                    <span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span>
                                  </div>
                                  <!--end::Toolbar-->
                                </div>
                              </div>
                              <!--end::Items-->
                            </div>
                            <!--end::Dropzone-->

                            <!--begin::Hint-->
                            <span class="form-text text-muted ms-5">حداکثر حجم فایل انتخابی 1 مگابایت می‌باشد</span>
                            <!--end::Hint-->
                          </div>
                          <!--end::Col-->
                        </div>
                        <!--end::Input group-->
                      </form>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <div>
                        <input class="d-none" id="dropzoneFiles" type="text" value="" />
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'textarea'" :class="field.required && field.errorCode ? 'wrong-inputs' : ''
                      ">
                      <editor v-model="info[field.name]" :api-key="tinymceToken" :init="{
                        menubar: field.menubar,
                        plugins: field.plugins
                          ? field.plugins
                          : tinyMCE_Def.plugins,
                        directionality: inlineRouteLocale == 'en' ? 'ltr' : field.directionality,
                        toolbar: field.toolbar
                          ? field.toolbar
                          : tinyMCE_Def.toolbar,
                        height: 500,
                      }" />
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <!-- <div :tabindex="index" v-else-if="field.type == 'time'">{{info[field.name]}}
                      <vue-date-picker
                        class="form-control form-control-solid form-control-lg border-0"
                        v-model="info[field.name]"
                        time-picker>
                      </vue-date-picker>
                    </div> -->
                    <div :tabindex="index" v-else-if="field.type == 'time'">
                      <!-- input-format="MM/DD/YYYY" -->
                      <date-picker class="form-control form-control-solid form-control-lg border-0" :class="`${field.class}
                          ${field.required && field.errorCode
                          ? 'wrong-inputs'
                          : ''
                        }`" :auto-submit="false" :locale="$route.params.locale" input-format="HH:mm" format="HH:mm"
                        color="#9277e4" type="time" v-model="info[field.name]"></date-picker>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'date'">
                      <!-- input-format="MM/DD/YYYY" -->
                      <date-picker class="form-control form-control-solid form-control-lg border-0" :class="`${field.class}
                          ${field.required && field.errorCode
                          ? 'wrong-inputs'
                          : ''
                        }`" :auto-submit="true" :locale="$route.params.locale" :input-format="$route.params.locale == 'fa'
                          ? 'jYYYY/jMM/jDD'
                          : 'YYYY/MM/DD'
                          " :format="$route.params.locale == 'fa'
                            ? 'jYYYY/jMM/jDD'
                            : 'YYYY/MM/DD'
                            " color="#9277e4" v-model="info[field.name]"></date-picker>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'datetime'">
                      <!-- input-format="MM/DD/YYYY" -->
                      <date-picker class="form-control form-control-solid form-control-lg border-0" :class="`${field.class}
                          ${field.required && field.errorCode
                          ? 'wrong-inputs'
                          : ''
                        }`" :auto-submit="true" :locale="$route.params.locale" :display-format="$route.params.locale == 'fa'
                          ? 'jYYYY/jMM/jDD HH:MM'
                          : 'YYYY/MM/DD HH:MM'
                          " :input-format="$route.params.locale == 'fa'
                            ? 'jYYYY/jMM/jDD HH:MM'
                            : 'YYYY/MM/DD HH:MM'
                            " :format="$route.params.locale == 'fa'
                              ? 'jYYYY/jMM/jDD HH:MM'
                              : 'YYYY/MM/DD HH:MM'
                              " color="#9277e4" type="datetime" v-model="info[field.name]"></date-picker>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'selectFile'">
                      <div @click="
                        setModalConfigs('choose', {
                          root: field.name,
                          depth: 1,
                        })
                        " class="fv-row">
                        <!--begin::Dropzone-->
                        <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                          id="kt_dropzonejs_example_1">
                          <!--begin::Message-->
                          <div v-if="
                            (info.photos && info.photos.length > 0) ||
                            (info[field.name] && info[field.name].length > 0)
                          " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                            <div v-for="photo in info[field.name] || info.photos" :key="photo"
                              class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                              <div class="symbol symbol-100px">
                                <img :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                              </div>
                            </div>
                          </div>
                          <div v-else class="dz-message needsclick">
                            <!--begin::Icon-->
                            <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                            <!--end::Icon-->

                            <!--begin::Info-->
                            <div class="ms-4">
                              <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                Click here to upload an image
                              </h3>
                              <span class="fs-7 fw-bold text-gray-400">Upload up to 10 files</span>
                            </div>
                            <!--end::Info-->
                          </div>
                        </div>
                        <!--end::Dropzone-->
                      </div>
                      <!-- <a
                        class="btn btn-primary btn-shadow ms-2"
                        :class="
                          field.required && field.errorCode ? 'wrong-inputs' : ''
                        "
                        @click="setModalConfigs('choose')"
                      >
                        انتخاب عکس
                      </a> -->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'selectTemplate'">
                      <div @click="
                        setModalConfigs('templates', {
                          value: field.name,
                          category: 'Forms',
                        })
                        " class="fv-row">
                        <!--begin::Dropzone-->
                        <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                          id="kt_dropzonejs_example_1">
                          <!--begin::Message-->
                          <div v-if="info[field.name]" class="d-flex flex-center flex-wrap scroll-y mh-200px">
                            <div
                              class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                              <div class="symbol symbol-100px">
                                <img :src="`${backendHost}/uploads/${$store.state.uploadsPath
                                  }/${info[field.name].templatePreview[0]}`" />
                              </div>
                            </div>
                          </div>
                          <div v-else class="dz-message needsclick">
                            <!--begin::Icon-->
                            <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                            <!--end::Icon-->

                            <!--begin::Info-->
                            <div class="ms-4">
                              <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                {{
                                  field.placeholder &&
                                    field.placeholder.length > 0
                                    ? field.placeholder
                                    : "Click here to select a template"
                                }}
                              </h3>
                              <span class="fs-7 fw-bold text-gray-400">Select just 1 template</span>
                            </div>
                            <!--end::Info-->
                          </div>
                        </div>
                        <!--end::Dropzone-->
                      </div>
                      <!-- <a
                        class="btn btn-primary btn-shadow ms-2"
                        :class="
                          field.required && field.errorCode ? 'wrong-inputs' : ''
                        "
                        @click="setModalConfigs('choose')"
                      >
                        انتخاب عکس
                      </a> -->
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'component'">
                      <div v-if="templateIndex !== ''">
                        <div v-for="(f, index) in info['blogBody'][
                          `${templateIndex}`
                        ].fields" :key="index" class="fv-row mb-8">
                          <!--begin::Label-->
                          <label :ref="f.name" class="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span class="required">{{ f.title }}</span>
                            <i class="bi bi-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                              title="Select your post image"></i>
                          </label>
                          <!--end::Label-->

                          <div v-if="f.type == 'selectFile'">
                            <!--begin::Input group-->
                            <div @click="setModalConfigs('choose')" class="fv-row">
                              <!--begin::Dropzone-->
                              <div class="dropzone dropzone__bg" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                " id="kt_dropzonejs_example_1">
                                <!--begin::Message-->
                                <div v-if="info.photos" class="shadow symbol symbol-100px card mb-7">
                                  <img v-for="photo in info.photos" :key="photo"
                                    :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                </div>
                                <div v-else class="dz-message needsclick">
                                  <!--begin::Icon-->
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <!--end::Icon-->

                                  <!--begin::Info-->
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                      Drop files here or click to upload.
                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Upload up to 10 files</span>
                                  </div>
                                  <!--end::Info-->
                                </div>
                              </div>
                              <!--end::Dropzone-->
                            </div>
                            <!--end::Input group-->
                            <!-- <a
                              class="btn btn-primary btn-shadow ms-2"
                              :class="
                                f.required && f.errorCode ? 'wrong-inputs' : ''
                              "
                              @click="setModalConfigs('choose')"
                            >
                              انتخاب عکس
                            </a> -->
                            <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ f.validation[f.errorCode - 1].error }}
                            </div>
                          </div>
                          <div v-else-if="f.type == 'text'">
                            <input :ref="`${f.name}_Input`" :placeholder="f.placeholder" v-model="f.value"
                              id="postTitle" type="text" class="form-control form-control-solid" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                " name="subject" />
                            <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ f.validation[f.errorCode - 1].error }}
                            </div>
                          </div>
                          <div v-else-if="f.type == 'description'">
                            <textarea :ref="`${f.name}_Input`" :placeholder="f.placeholder" v-model="f.value"
                              :id="f.name" rows="5" class="form-control form-control-solid" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                                " name="subject"></textarea>
                            <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ f.validation[f.errorCode - 1].error }}
                            </div>
                          </div>
                          <div v-else-if="f.type == 'textarea'" :class="f.required && f.errorCode ? 'wrong-inputs' : ''
                            ">
                            <editor v-model="f.value" :api-key="tinymceToken" :init="{
                              menubar: true,
                              plugins: 'lists link emoticons directionality',
                              directionality:
                                info['blogLocale'] == 'fa' ? 'rtl' : 'ltr',
                              toolbar:
                                'styleselect | bold italic | alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist | link emoticons',
                              height: 200,
                            }" />
                            <div v-if="f.required && f.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ f.validation[f.errorCode - 1].error }}
                            </div>
                          </div>
                          <div id="chapterAccordion" :tabindex="index" v-if="f.type == 'card'">
                            <div v-for="(subField, index) in f.value.length" :key="subField"
                              class="card border border-gray-300 mb-5">
                              <div class="card-header">
                                <!-- :class="index != 0 ? 'collapsed' : ''" -->
                                <div class="card-title collapsible cursor-pointer text-hover-primary rotate"
                                  data-bs-toggle="collapse" :data-bs-target="`#kt_${f.name}_collapsible_${index}`">
                                  <span v-if="f.title.length > 0" class="fs-2 fw-bolder">{{ f.title }} {{ index + 1
                                  }}</span>
                                </div>
                                <div class="card-toolbar gap-3">
                                  <a href="#" @click="addComponentChild(f.value, f.default)"
                                    class="btn btn-sm btn-icon btn-light-primary"><i
                                      class="bi bi-folder-plus fs-3"></i></a>
                                  <a href="#" @click="delComponentChild(f.value, index)"
                                    class="btn btn-sm btn-icon btn-light-danger"><i class="bi bi-trash fs-3"></i></a>
                                  <div class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                                    :class="index != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                                    :data-bs-target="`#kt_${f.name}_collapsible_${index}`">
                                    <div class="rotate-180">
                                      <span class="svg-icon svg-icon-1">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                            fill="currentColor"></path>
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div :id="`kt_${f.name}_collapsible_${index}`" data-bs-parent="#chapterAccordion"
                                class="collapse" :class="index == 0 ? 'show' : ''">
                                <div class="card-body">
                                  <div>
                                    <div v-for="(item, i) in f.fields" :key="i" class="fv-row mb-10">
                                      <div v-if="item.editable || modalInfo.status">
                                        <div v-if="item.type !== 'card'" class="d-flex justify-content-between">
                                          <label v-if="item.title.length > 0" class="fs-5 fw-bolder form-label mb-2">
                                            <span :class="item.required ? 'required' : ''
                                              ">{{ item.title }}
                                              {{ index + 1 }}</span>
                                          </label>
                                        </div>
                                        <div>
                                          <div :tabindex="index" v-if="item.type == 'text'">
                                            {{ item.errorCode }}
                                            <input :ref="`${item.name}_Input`" :minlength="item.minLength"
                                              :maxlength="item.maxLength" class="form-control form-control-solid p-4"
                                              :class="item.required && item.errorCode
                                                ? 'wrong-inputs'
                                                : ''
                                                " :disabled="item.disabled ? true : false
                                                  " aria-describedby="validationErrorFeedback" :type="item.type"
                                              :placeholder="`${item.placeholder}`"
                                              v-model="f.value[index][item.name]" />
                                            <div v-if="
                                              item.required &&
                                              item.errorCode > 0
                                            " id="validationErrorFeedback" class="invalid-feedback d-block">
                                              {{
                                                item.validation[
                                                  item.errorCode - 1
                                                ].error
                                              }}
                                            </div>
                                          </div>
                                          <div :tabindex="index" v-else-if="item.type == 'textarea'" :class="item.required && item.errorCode
                                            ? 'wrong-inputs'
                                            : ''
                                            ">
                                            <editor v-model="f.value[index][item.name]" :api-key="tinymceToken" :init="{
                                              menubar: f.menubar,
                                              plugins: f.plugins
                                                ? f.plugins
                                                : tinyMCE_Def.plugins,
                                              directionality: f.directionality,
                                              toolbar: f.toolbar
                                                ? f.toolbar
                                                : tinyMCE_Def.toolbar,
                                              height: 200,
                                            }" />
                                          </div>
                                          <div :tabindex="index" v-else-if="item.type == 'selectFile'">
                                            <div @click="
                                              setModalConfigs('choose', {
                                                root: f.name,
                                                index: index,
                                                child: item.name,
                                                depth: 3,
                                              })
                                              " class="fv-row">
                                              <!--begin::Dropzone-->
                                              <div
                                                class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                                id="kt_dropzonejs_example_1">
                                                <!--begin::Message-->
                                                {{ f.value[index][item.name] }}
                                                <div v-if="
                                                  f.value &&
                                                  f.value[index][item.name]
                                                    .length > 0
                                                " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                                  <div v-for="photo in [
                                                    f.value[index][item.name],
                                                  ]" :key="photo"
                                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                                    <div class="symbol symbol-100px">
                                                      <img
                                                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div v-else class="dz-message needsclick">
                                                  <!--begin::Icon-->
                                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                                  <!--end::Icon-->

                                                  <!--begin::Info-->
                                                  <div class="ms-4">
                                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                      Click here to upload an
                                                      image
                                                    </h3>
                                                    <span class="fs-7 fw-bold text-gray-400">Upload up to 10
                                                      files</span>
                                                  </div>
                                                  <!--end::Info-->
                                                </div>
                                              </div>
                                              <!--end::Dropzone-->
                                            </div>
                                            <!-- <a
                                            class="btn btn-primary btn-shadow ms-2"
                                            :class="
                                              field.required && field.errorCode ? 'wrong-inputs' : ''
                                            "
                                            @click="setModalConfigs('choose')"
                                          >
                                            انتخاب عکس
                                          </a> -->
                                            <div v-if="
                                              field.required &&
                                              field.errorCode > 0
                                            " id="validationErrorFeedback" class="invalid-feedback d-block">
                                              {{
                                                field.validation[
                                                  field.errorCode - 1
                                                ].error
                                              }}
                                            </div>
                                          </div>
                                          <div :id="`sessionAccordion_${index}`" :tabindex="index"
                                            v-if="item.type == 'card'">
                                            <div v-for="(subItem, iii) in info[
                                              field.name
                                            ][subField - 1][item.name].length" :key="subItem" class="card border mb-5">
                                              <div class="card-header">
                                                <div @click="
                                                  nestedAccordion(
                                                    `sessionAccordion_${index}`,
                                                    `#kt_${item.title}_${index}_collapsible_${iii}`
                                                  )
                                                  "
                                                  class="card-title collapsible cursor-pointer text-hover-primary rotate"
                                                  :class="iii != 0 ? 'collapsed' : ''
                                                    " data-bs-toggle="collapse"
                                                  :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                                  <span v-if="item.title.length > 0" class="fs-2 fw-bolder">{{
                                                    item.title }}
                                                    {{ index + 1 }}.{{
                                                      iii + 1
                                                    }}</span>
                                                </div>
                                                <div class="card-toolbar gap-3">
                                                  <a href="#" @click="
                                                    addChild(
                                                      field.name,
                                                      subField - 1,
                                                      item.name,
                                                      item.value
                                                    )
                                                    " class="btn btn-sm btn-icon btn-light-primary"><i
                                                      class="bi bi-folder-plus fs-3"></i></a>
                                                  <a href="#" @click="
                                                    delChild(
                                                      field.name,
                                                      subField - 1,
                                                      item.name
                                                    )
                                                    " class="btn btn-sm btn-icon btn-light-danger"><i
                                                      class="bi bi-trash fs-3"></i></a>
                                                  <div @click="
                                                    nestedAccordion(
                                                      `sessionAccordion_${index}`,
                                                      `#kt_${item.title}_${index}_collapsible_${iii}`
                                                    )
                                                    " :id="`kt_${item.title}_${index}_collapsible_${iii}_button`"
                                                    class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                                                    :class="iii != 0 ? 'collapsed' : ''
                                                      " data-bs-toggle="collapse"
                                                    :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                                    <div class="rotate-180">
                                                      <span class="svg-icon svg-icon-white svg-icon-1">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                          xmlns="http://www.w3.org/2000/svg">
                                                          <path
                                                            d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                                            fill="currentColor"></path>
                                                        </svg>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div :id="`kt_${item.title}_${index}_collapsible_${iii}`"
                                                :data-bs-parent="`#sessionAccordion_${index}`" class="collapse"
                                                :class="iii == 0 ? 'show' : ''">
                                                <div class="card-body">
                                                  <div v-for="(
it, ii
                                                    ) in item.fields" :key="ii" class="fv-row mb-10">
                                                    <div v-if="
                                                      it.editable ||
                                                      modalInfo.status
                                                    ">
                                                      <div class="d-flex justify-content-between">
                                                        <label v-if="
                                                          it.title.length > 0
                                                        " class="fs-5 fw-bolder form-label mb-2">
                                                          <span :class="item.required
                                                            ? 'required'
                                                            : ''
                                                            ">{{ it.title }}
                                                            {{ index + 1 }}.{{
                                                              iii + 1
                                                            }}</span>
                                                        </label>
                                                        <div v-if="
                                                          info[field.name][
                                                          subField - 1
                                                          ][item.name][
                                                          subItem - 1
                                                          ][it.name] &&
                                                          info[field.name][
                                                            subField - 1
                                                          ][item.name][
                                                            subItem - 1
                                                          ][it.name].length &&
                                                          it.maxLength &&
                                                          it.maxLength !== -1
                                                        " class="d-flex justify-content-end text-secondary">
                                                          {{
                                                            info[field.name][
                                                              subField - 1
                                                            ][item.name][
                                                              subItem - 1
                                                            ][it.name].length
                                                          }}
                                                          /
                                                          {{ it.maxLength }}
                                                        </div>
                                                        <div v-else-if="
                                                          it.maxTags &&
                                                          it.maxTags !== -1
                                                        " class="d-flex justify-content-end text-secondary">
                                                          0 / {{ it.maxLength }}
                                                        </div>
                                                      </div>
                                                      <div :tabindex="index" v-if="it.type == 'text'">
                                                        {{ it.errorCode }}
                                                        <input :ref="`${it.name}_Input`" :minlength="it.minLength
                                                          " :maxlength="it.maxLength
                                                            " class="form-control form-control-solid p-4" :class="it.required &&
                                                              it.errorCode
                                                              ? 'wrong-inputs'
                                                              : ''
                                                              " :disabled="it.disabled
                                                                ? true
                                                                : false
                                                                " aria-describedby="validationErrorFeedback"
                                                          :type="it.type" :placeholder="`${it.placeholder}`" v-model="info[field.name][
                                                            subField - 1
                                                          ][item.name][
                                                            subItem - 1
                                                          ][it.name]
                                                            " />
                                                        <div v-if="
                                                          it.required &&
                                                          it.errorCode > 0
                                                        " id="validationErrorFeedback"
                                                          class="invalid-feedback d-block">
                                                          {{
                                                            it.validation[
                                                              it.errorCode - 1
                                                            ].error
                                                          }}
                                                        </div>
                                                      </div>
                                                      <div :tabindex="index" v-else-if="
                                                        it.type == 'icon'
                                                      ">
                                                        {{ it.errorCode }}
                                                        <multiselect :close-on-select="true" :filter-results="false"
                                                          :min-chars="0" :resolve-on-load="true" :infinite="true"
                                                          :limit="10" :clear-on-search="true" :delay="0" mode="single"
                                                          :canDeselect="false" :hideSelected="true"
                                                          class="form-control form-control-solid p-5" :class="item.required &&
                                                            item.errorCode
                                                            ? 'wrong-inputs'
                                                            : ''
                                                            " :placeholder="item.placeholder
                                                              " label="title" v-model="info[field.name][
                                                                subField - 1
                                                              ][item.name][
                                                                subItem - 1
                                                              ][it.name]
                                                                " :searchable="true" :options="async (
                                                                  query,
                                                                  i,
                                                                  r
                                                                ) => {
                                                                  return await fetchIcons(
                                                                    query
                                                                  );
                                                                }
                                                                  " @open="
                                                                  (select$) => {
                                                                    if (
                                                                      select$.noOptions
                                                                    ) {
                                                                      select$.resolveOptions();
                                                                    }
                                                                  }
                                                                ">
                                                          <template v-slot:singlelabel="{
                                                            value,
                                                          }">
                                                            <div class="multiselect-single-label">
                                                              <i class="me-2" :class="value.value
                                                                "></i>
                                                              {{ value.title }}
                                                            </div>
                                                          </template>
                                                          <template v-slot:option="{
                                                            option,
                                                          }">
                                                            <i class="me-2" :class="option.value
                                                              "></i>
                                                            {{ option.title }}
                                                          </template>
                                                        </multiselect>
                                                        <div v-if="
                                                          item.required &&
                                                          item.errorCode > 0
                                                        " id="validationErrorFeedback"
                                                          class="invalid-feedback d-block">
                                                          {{
                                                            item.validation[
                                                              item.errorCode - 1
                                                            ].error
                                                          }}
                                                        </div>
                                                      </div>
                                                      <div :tabindex="index" v-else-if="
                                                        it.type == 'selectFile'
                                                      ">
                                                        <div @click="
                                                          setModalConfigs(
                                                            'choose',
                                                            {
                                                              root: field.name,
                                                              index:
                                                                subField - 1,
                                                              child: item.name,
                                                              childIndex:
                                                                subItem - 1,
                                                              grandchild:
                                                                it.name,
                                                              depth: 5,
                                                            }
                                                          )
                                                          " class="fv-row">
                                                          <!--begin::Dropzone-->
                                                          <div
                                                            class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                                            id="kt_dropzonejs_example_1">
                                                            <!--begin::Message-->
                                                            <div v-if="
                                                              info[field.name][
                                                              subField - 1
                                                              ][item.name][
                                                              subItem - 1
                                                              ][it.name] &&
                                                              info[field.name][
                                                                subField - 1
                                                              ][item.name][
                                                                subItem - 1
                                                              ][it.name]
                                                                .length > 0
                                                            " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                                              <div v-for="photo in info[
                                                                field.name
                                                              ][subField - 1][
                                                                item.name
                                                              ][subItem - 1][
                                                                it.name
                                                              ]" :key="photo"
                                                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6 col-md-3">
                                                                <div class="symbol symbol-100px">
                                                                  <img
                                                                    :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <div v-else class="dz-message needsclick">
                                                              <!--begin::Icon-->
                                                              <i
                                                                class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                                              <!--end::Icon-->

                                                              <!--begin::Info-->
                                                              <div class="ms-4">
                                                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                                  Drop files here
                                                                  or click to
                                                                  upload.
                                                                </h3>
                                                                <span class="fs-7 fw-bold text-gray-400">Upload up to 10
                                                                  files</span>
                                                              </div>
                                                              <!--end::Info-->
                                                            </div>
                                                          </div>
                                                          <!--end::Dropzone-->
                                                        </div>
                                                        <div v-if="
                                                          field.required &&
                                                          field.errorCode > 0
                                                        " id="validationErrorFeedback"
                                                          class="invalid-feedback d-block">
                                                          {{
                                                            field.validation[
                                                              field.errorCode - 1
                                                            ].error
                                                          }}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    class="separator separator-content separator-dashed mb-20 my-15 border-gray-300 text-primary text-nowrap">
                                                    End of Session
                                                    {{ index + 1 }}.{{ iii + 1 }}
                                                  </div>
                                                  <div v-if="
                                                    field.required &&
                                                    field.errorCode > 0
                                                  " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                    {{
                                                      field.validation[
                                                        field.errorCode - 1
                                                      ].error
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                                    class="invalid-feedback d-block">
                                    {{
                                      field.validation[field.errorCode - 1].error
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else
                        class="min-h-50px d-flex justify-content-center align-items-center text-danger fw-bold fs-2 text-center border-dotted">
                        Choose a template {{ info }}
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'countdown'">
                      <label v-if="verifyTime" class="form-label text-muted __bottom__label">{{ field.title.before
                      }}</label>
                      <label v-else class="form-label text-muted __bottom__label">
                        <a href="#" class="__text__primary text-decoration-none" @click="closeModal('timer')">{{
                          field.title.after }}</a></label>

                      <span class="ms-2 __text__primary fs-5">{{
                        countDown
                      }}</span>
                    </div>
                    <div id="chapterAccordion" :tabindex="index" v-if="field.type == 'card' && pac">
                      <div v-for="(subField, index) in info[field.name].length" :key="subField"
                        class="card border border-gray-300 mb-5">
                        <div class="card-header">
                          <div class="card-title collapsible cursor-pointer text-hover-primary rotate"
                            :class="index != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                            :data-bs-target="`#kt_${field.name.replace('->', '')}_collapsible_${index}`">
                            <span v-if="field.title.length > 0" class="fs-2 fw-bolder">{{ field.title }} {{ index + 1
                            }}</span>
                          </div>
                          <div class="card-toolbar gap-3">
                            <a v-if="index > 0" href="#" @click="changeOrder(info[field.name], index, 'up')"
                              class="btn btn-sm btn-icon btn-light"><i class="bi bi-arrow-up fs-3"></i></a>
                            <a v-if="index < info[field.name].length - 1" href="#" @click="
                              changeOrder(info[field.name], index, 'down')
                              " class="btn btn-sm btn-icon btn-light"><i class="bi bi-arrow-down fs-3"></i></a>
                            <a href="#" @click="
                              addChild(
                                field.name,
                                subField,
                                null,
                                field.value,
                                field
                              )
                              " class="btn btn-sm btn-icon btn-light-primary"><i
                                class="bi bi-folder-plus fs-3"></i></a>
                            <a href="#" @click="delChild(field.name, subField, null)"
                              class="btn btn-sm btn-icon btn-light-danger"><i class="bi bi-trash fs-3"></i></a>
                            <div class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                              :class="index != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                              :data-bs-target="`#kt_${field.name.replace('->', '')}_collapsible_${index}`">
                              <div class="rotate-180">
                                <span class="svg-icon svg-icon-1">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                      fill="currentColor"></path>
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div :id="`kt_${field.name.replace('->', '')}_collapsible_${index}`"
                          data-bs-parent="#chapterAccordion" class="collapse" :class="index == 0 ? 'show' : ''">
                          <div class="card-body">
                            <div>
                              <div v-for="(item, i) in field.fields" :key="i" class="fv-row mb-10">
                                <div v-if="item.editable || modalInfo.status">
                                  <div v-if="item.type !== 'card'" class="d-flex justify-content-between">
                                    <label v-if="item.title.length > 0" class="fs-5 fw-bolder form-label mb-2">
                                      <span :class="item.required ? 'required' : ''">{{ item.title }} {{ index + 1
                                      }}</span>
                                    </label>
                                    <div v-if="
                                      info[field.name][item.name] &&
                                      info[field.name][item.name].length &&
                                      item.maxLength &&
                                      item.maxLength !== -1
                                    " class="d-flex justify-content-end text-secondary">
                                      {{
                                        info[`${field.name}_${item.name}`].length
                                      }}
                                      /
                                      {{ item.maxLength }}
                                    </div>
                                    <div v-else-if="
                                      item.maxTags && item.maxTags !== -1
                                    " class="d-flex justify-content-end text-secondary">
                                      0 / {{ item.maxLength }}
                                    </div>
                                  </div>
                                  <div>
                                    <div :tabindex="index" v-if="item.type == 'text'">
                                      <input :ref="`${item.name}_Input`" :minlength="item.minLength"
                                        :maxlength="item.maxLength" class="form-control form-control-solid p-4" :class="item.required && item.errorCode
                                          ? 'wrong-inputs'
                                          : ''
                                          " :disabled="item.disabled ? true : false"
                                        aria-describedby="validationErrorFeedback" :type="item.type"
                                        :placeholder="`${item.placeholder}`" v-model="info[field.name][subField - 1][
                                          item.name
                                        ]
                                          " />
                                      <div v-if="item.required && item.errorCode > 0" id="validationErrorFeedback"
                                        class="invalid-feedback d-block">
                                        {{
                                          item.validation[item.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :tabindex="index" v-else-if="item.type == 'summary'">
                                      <textarea :dir="inlineRouteLocale == 'fa'
                                        ? 'rtl'
                                        : 'ltr'
                                        " :ref="`${item.name}_Input`" :placeholder="item.placeholder" v-model="info[field.name][subField - 1][
                                          item.name
                                        ]
                                          " :id="item.name" :rows="item.rows" class="form-control form-control-solid"
                                        :class="item.required && item.errorCode
                                          ? 'wrong-inputs'
                                          : ''
                                          "></textarea>
                                      <div v-if="item.required && item.errorCode > 0" id="validationErrorFeedback"
                                        class="invalid-feedback d-block">
                                        {{
                                          item.validation[item.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :tabindex="index" v-else-if="item.type == 'textarea'" :class="item.required && item.errorCode
                                      ? 'wrong-inputs'
                                      : ''
                                      ">
                                      <editor v-model="info[field.name][subField - 1][
                                        item.name
                                      ]
                                        " :api-key="tinymceToken" :init="{
                                          menubar: field.menubar,
                                          plugins: field.plugins
                                            ? field.plugins
                                            : tinyMCE_Def.plugins,
                                          directionality: field.directionality,
                                          toolbar: field.toolbar
                                            ? field.toolbar
                                            : tinyMCE_Def.toolbar,
                                          height: 200,
                                        }" />
                                    </div>
                                    <div :tabindex="index" v-if="item.type == 'combobox'">
                                      {{ item.errorCode }}
                                      <multiselect mode="single" :canDeselect="false" :hideSelected="true"
                                        @click="setOfset(item)" class="form-control form-control-solid p-5" :class="item.required && item.errorCode
                                          ? 'wrong-inputs'
                                          : ''
                                          " :placeholder="item.placeholder" label="title" v-model="info[field.name][index][item.name]
                                            " :searchable="true" :options="item.options">
                                        <template v-slot:option="{ option }">
                                          {{ option.title }}
                                        </template>
                                      </multiselect>
                                      <div v-if="item.required && item.errorCode > 0" id="validationErrorFeedback"
                                        class="invalid-feedback d-block">
                                        {{
                                          item.validation[item.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :tabindex="index" v-if="
                                      item.type == 'multiselect' &&
                                      item.shows &&
                                      item.shows.rel.includes('->') &&
                                      info[field.name][index][
                                      item.shows.rel.split('->')[1]
                                      ] == item.shows.value
                                    ">
                                      {{ item.errorCode }}
                                      <multiselect class="form-control form-control-solid" :class="item.required && item.errorCode
                                        ? 'wrong-inputs'
                                        : ''
                                        " v-model="info[field.name][index][item.name]
                                          " :placeholder="item.placeholder" mode="tags" :max="item.maxTags"
                                        label="title" :close-on-select="false" :searchable="true"
                                        :options="item.options" />
                                      <div v-if="item.required && item.errorCode > 0" id="validationErrorFeedback"
                                        class="invalid-feedback d-block">
                                        {{
                                          item.validation[item.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :tabindex="index" v-else-if="item.type == 'icon'">
                                      {{ item.errorCode }}
                                      <multiselect :close-on-select="true" :filter-results="false" :min-chars="0"
                                        :resolve-on-load="true" :infinite="true" :limit="10" :clear-on-search="true"
                                        :delay="0" mode="single" :canDeselect="false" :hideSelected="true"
                                        class="form-control form-control-solid p-5" :class="item.required && item.errorCode
                                          ? 'wrong-inputs'
                                          : ''
                                          " :placeholder="item.placeholder" label="title" v-model="info[field.name][subField - 1][
                                            item.name
                                          ]
                                            " :searchable="true" :options="async (query, i, r) => {
                                              return await fetchIcons(query);
                                            }
                                              " @open="
                                                (select$) => {
                                                  if (select$.noOptions) {
                                                    select$.resolveOptions();
                                                  }
                                                }
                                              ">
                                        <template v-slot:singlelabel="{ value }">
                                          <div class="multiselect-single-label">
                                            <i class="me-2" :class="value.value"></i>
                                            {{ value.title }}
                                          </div>
                                        </template>
                                        <template v-slot:option="{ option }">
                                          <i class="me-2" :class="option.value"></i>
                                          {{ option.title }}
                                        </template>
                                      </multiselect>
                                      <div v-if="item.required && item.errorCode > 0" id="validationErrorFeedback"
                                        class="invalid-feedback d-block">
                                        {{
                                          item.validation[item.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :tabindex="index" v-else-if="item.type == 'selectFile'">
                                      <div @click="
                                        setModalConfigs('choose', {
                                          root: field.name,
                                          index: index,
                                          child: item.name,
                                          depth: 3,
                                        })
                                        " class="fv-row">
                                        <!--begin::Dropzone-->
                                        <div
                                          class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                          id="kt_dropzonejs_example_1">
                                          <!--begin::Message-->
                                          {{ info[field.name][index][item.name] }}
                                          {{ field.name }} {{ item.name }}
                                          <div v-if="
                                            info[field.name] &&
                                            info[field.name][index][item.name]
                                              .length > 0
                                          " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                            <div v-for="photo in [
                                              info[field.name][index][
                                              item.name
                                              ],
                                            ]" :key="photo"
                                              class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                              <div class="symbol symbol-100px">
                                                <img
                                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else class="dz-message needsclick">
                                            <!--begin::Icon-->
                                            <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                            <!--end::Icon-->

                                            <!--begin::Info-->
                                            <div class="ms-4">
                                              <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                Click here to upload an image
                                              </h3>
                                              <span class="fs-7 fw-bold text-gray-400">Upload up to 10 files</span>
                                            </div>
                                            <!--end::Info-->
                                          </div>
                                        </div>
                                        <!--end::Dropzone-->
                                      </div>
                                      <!-- <a
                                        class="btn btn-primary btn-shadow ms-2"
                                        :class="
                                          field.required && field.errorCode ? 'wrong-inputs' : ''
                                        "
                                        @click="setModalConfigs('choose')"
                                      >
                                        انتخاب عکس
                                      </a> -->
                                      <div v-if="
                                        field.required && field.errorCode > 0
                                      " id="validationErrorFeedback" class="invalid-feedback d-block">
                                        {{
                                          field.validation[field.errorCode - 1]
                                            .error
                                        }}
                                      </div>
                                    </div>
                                    <div :id="`sessionAccordion_${index}`" :tabindex="index" v-if="item.type == 'card'">
                                      <div v-for="(subItem, iii) in info[field.name][
                                        subField - 1
                                      ][item.name].length" :key="subItem" class="card border mb-5">
                                        <div class="card-header">
                                          <div @click="
                                            nestedAccordion(
                                              `sessionAccordion_${index}`,
                                              `#kt_${item.title}_${index}_collapsible_${iii}`
                                            )
                                            " class="card-title collapsible cursor-pointer text-hover-primary rotate"
                                            :class="iii != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                                            :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                            <span v-if="item.title.length > 0" class="fs-2 fw-bolder">{{ item.title }}
                                              {{
                                                index + 1 }}.{{
                                                iii + 1
                                              }}</span>
                                          </div>
                                          <div class="card-toolbar gap-3">
                                            <a href="#" @click="
                                              addChild(
                                                field.name,
                                                subField - 1,
                                                item.name,
                                                item.value
                                              )
                                              " class="btn btn-sm btn-icon btn-light-primary"><i
                                                class="bi bi-folder-plus fs-3"></i></a>
                                            <a href="#" @click="
                                              delChild(
                                                field.name,
                                                subField - 1,
                                                item.name
                                              )
                                              " class="btn btn-sm btn-icon btn-light-danger"><i
                                                class="bi bi-trash fs-3"></i></a>
                                            <div @click="
                                              nestedAccordion(
                                                `sessionAccordion_${index}`,
                                                `#kt_${item.title}_${index}_collapsible_${iii}`
                                              )
                                              " :id="`kt_${item.title}_${index}_collapsible_${iii}_button`"
                                              class="btn btn-sm btn-icon btn-light collapsible cursor-pointer rotate"
                                              :class="iii != 0 ? 'collapsed' : ''" data-bs-toggle="collapse"
                                              :data-bs-target="`#kt_${item.title}_${index}_collapsible_${iii}`">
                                              <div class="rotate-180">
                                                <span class="svg-icon svg-icon-white svg-icon-1">
                                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                      d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                                      fill="currentColor"></path>
                                                  </svg>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div :id="`kt_${item.title}_${index}_collapsible_${iii}`"
                                          :data-bs-parent="`#sessionAccordion_${index}`" class="collapse"
                                          :class="iii == 0 ? 'show' : ''">
                                          <div class="card-body">
                                            <div v-for="(it, ii) in item.fields" :key="ii" class="fv-row mb-10">
                                              <div v-if="
                                                it.editable || modalInfo.status
                                              ">
                                                <div class="d-flex justify-content-between">
                                                  <label v-if="it.title.length > 0"
                                                    class="fs-5 fw-bolder form-label mb-2">
                                                    <span :class="item.required
                                                      ? 'required'
                                                      : ''
                                                      ">{{ it.title }}
                                                      {{ index + 1 }}.{{
                                                        iii + 1
                                                      }}</span>
                                                  </label>
                                                  <div v-if="
                                                    info[field.name][
                                                    subField - 1
                                                    ][item.name][subItem - 1][
                                                    it.name
                                                    ] &&
                                                    info[field.name][
                                                      subField - 1
                                                    ][item.name][subItem - 1][
                                                      it.name
                                                    ].length &&
                                                    it.maxLength &&
                                                    it.maxLength !== -1
                                                  " class="d-flex justify-content-end text-secondary">
                                                    {{
                                                      info[field.name][
                                                        subField - 1
                                                      ][item.name][subItem - 1][
                                                        it.name
                                                      ].length
                                                    }}
                                                    /
                                                    {{ it.maxLength }}
                                                  </div>
                                                  <div v-else-if="
                                                    it.maxTags &&
                                                    it.maxTags !== -1
                                                  " class="d-flex justify-content-end text-secondary">
                                                    0 / {{ it.maxLength }}
                                                  </div>
                                                </div>
                                                <div :tabindex="index" v-if="it.type == 'text'">
                                                  {{ it.errorCode }}
                                                  <input :ref="`${it.name}_Input`" :minlength="it.minLength"
                                                    :maxlength="it.maxLength"
                                                    class="form-control form-control-solid p-4" :class="it.required && it.errorCode
                                                      ? 'wrong-inputs'
                                                      : ''
                                                      " :disabled="it.disabled ? true : false
                                                        " aria-describedby="validationErrorFeedback" :type="it.type"
                                                    :placeholder="`${it.placeholder}`" v-model="info[field.name][
                                                      subField - 1
                                                    ][item.name][subItem - 1][
                                                      it.name
                                                    ]
                                                      " />
                                                  <div v-if="
                                                    it.required &&
                                                    it.errorCode > 0
                                                  " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                    {{
                                                      it.validation[
                                                        it.errorCode - 1
                                                      ].error
                                                    }}
                                                  </div>
                                                </div>
                                                <div :tabindex="index" v-else-if="it.type == 'icon'">
                                                  {{ it.errorCode }}
                                                  <multiselect :close-on-select="true" :filter-results="false"
                                                    :min-chars="0" :resolve-on-load="true" :infinite="true" :limit="10"
                                                    :clear-on-search="true" :delay="0" mode="single"
                                                    :canDeselect="false" :hideSelected="true"
                                                    class="form-control form-control-solid p-5" :class="item.required &&
                                                      item.errorCode
                                                      ? 'wrong-inputs'
                                                      : ''
                                                      " :placeholder="item.placeholder
                                                        " label="title" v-model="info[field.name][
                                                          subField - 1
                                                        ][item.name][subItem - 1][
                                                          it.name
                                                        ]
                                                          " :searchable="true" :options="async (query, i, r) => {
                                                            return await fetchIcons(
                                                              query
                                                            );
                                                          }
                                                            " @open="
                                                            (select$) => {
                                                              if (select$.noOptions) {
                                                                select$.resolveOptions();
                                                              }
                                                            }
                                                          ">
                                                    <template v-slot:singlelabel="{
                                                      value,
                                                    }">
                                                      <div class="multiselect-single-label">
                                                        <i class="me-2" :class="value.value"></i>
                                                        {{ value.title }}
                                                      </div>
                                                    </template>
                                                    <template v-slot:option="{ option }">
                                                      <i class="me-2" :class="option.value"></i>
                                                      {{ option.title }}
                                                    </template>
                                                  </multiselect>
                                                  <div v-if="
                                                    item.required &&
                                                    item.errorCode > 0
                                                  " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                    {{
                                                      item.validation[
                                                        item.errorCode - 1
                                                      ].error
                                                    }}
                                                  </div>
                                                </div>
                                                <div :tabindex="index" v-else-if="
                                                  it.type == 'selectFile'
                                                ">
                                                  <div @click="
                                                    setModalConfigs('choose', {
                                                      root: field.name,
                                                      index: subField - 1,
                                                      child: item.name,
                                                      childIndex: subItem - 1,
                                                      grandchild: it.name,
                                                      depth: 5,
                                                    })
                                                    " class="fv-row">
                                                    <!--begin::Dropzone-->
                                                    <div
                                                      class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                                      id="kt_dropzonejs_example_1">
                                                      <!--begin::Message-->
                                                      <div v-if="
                                                        info[field.name][
                                                        subField - 1
                                                        ][item.name][
                                                        subItem - 1
                                                        ][it.name] &&
                                                        info[field.name][
                                                          subField - 1
                                                        ][item.name][
                                                          subItem - 1
                                                        ][it.name].length > 0
                                                      " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                                        <div v-for="photo in info[
                                                          field.name
                                                        ][subField - 1][
                                                          item.name
                                                        ][subItem - 1][it.name]" :key="photo"
                                                          class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6 col-md-3">
                                                          <div class="symbol symbol-100px">
                                                            <img
                                                              :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`" />
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-else class="dz-message needsclick">
                                                        <!--begin::Icon-->
                                                        <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                                        <!--end::Icon-->

                                                        <!--begin::Info-->
                                                        <div class="ms-4">
                                                          <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                                            Drop files here or
                                                            click to upload.
                                                          </h3>
                                                          <span class="fs-7 fw-bold text-gray-400">Upload up to 10
                                                            files</span>
                                                        </div>
                                                        <!--end::Info-->
                                                      </div>
                                                    </div>
                                                    <!--end::Dropzone-->
                                                  </div>
                                                  <div v-if="
                                                    field.required &&
                                                    field.errorCode > 0
                                                  " id="validationErrorFeedback" class="invalid-feedback d-block">
                                                    {{
                                                      field.validation[
                                                        field.errorCode - 1
                                                      ].error
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="separator separator-content separator-dashed mb-20 my-15 border-gray-300 text-primary text-nowrap">
                                              End of Session
                                              {{ index + 1 }}.{{ iii + 1 }}
                                            </div>
                                            <div v-if="
                                              field.required &&
                                              field.errorCode > 0
                                            " id="validationErrorFeedback" class="invalid-feedback d-block">
                                              {{
                                                field.validation[
                                                  field.errorCode - 1
                                                ].error
                                              }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ field.validation[field.errorCode - 1].error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'array'">
                      <!--begin::Table wrapper-->
                      <div v-if="info.display" class="table-responsive">
                        <!--begin::Table-->
                        <table v-if="field.value[0].type == 'checkbox'"
                          class="table align-middle table-row-dashed fs-6 gy-5">
                          <!--begin::Table body-->
                          <tbody class="text-gray-600 fw-bold">
                            <!--begin::Table row-->
                            <tr v-for="value in field.value" :key="value.title">
                              <!--begin::Label-->
                              <td class="text-gray-800">
                                {{ value.title }}
                              </td>
                              <!--end::Label-->
                              <!--begin::Options-->
                              <td>
                                <!--begin::Wrapper-->
                                <div class="d-flex">
                                  <!--begin::Checkbox-->
                                  <label @click="chooseRow($event, field.name, value)"
                                    class="form-check form-check-sm form-check-custom form-check-solid me-5">
                                    <input class="form-check-input" type="checkbox" />
                                    <span class="form-check-label">All</span>
                                  </label>
                                  <!--end::Checkbox-->
                                </div>
                                <!--end::Wrapper-->
                              </td>
                              <td v-for="(item, index) in value.items" :key="index">
                                <!--begin::Wrapper-->
                                <div class="d-flex">
                                  <!--begin::Checkbox-->
                                  <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                                    <input class="form-check-input" :type="value.type" name="user_management_read"
                                      v-model="info[field.name][value.name][index]
                                        " />
                                    <span class="form-check-label">{{ item.title }}
                                    </span>
                                  </label>
                                  <!--end::Checkbox-->
                                </div>
                                <!--end::Wrapper-->
                              </td>
                              <!--end::Options-->
                            </tr>
                            <!--end::Table row-->
                          </tbody>
                          <!--end::Table body-->
                        </table>
                        <!--end::Table-->
                        <div v-if="field.value[0].type == 'text'">
                          <div v-for="(value, index) in field.value" :key="index" class="fv-row">
                            <label class="fs-5 fw-bolder form-label mb-2">
                              <span :class="value.required ? 'required' : ''">{{
                                value.title
                              }}</span>
                            </label>

                            <input class="form-control form-control-solid" :class="value.required && value.errorCode
                              ? 'wrong-inputs'
                              : ''
                              " :disabled="value.disabled ? true : false" aria-describedby="validationErrorFeedback"
                              :type="value.type" :placeholder="`${value.placeholder}`"
                              v-model="info[field.name][value.name]" />
                            <div v-if="value.required && value.errorCode > 0" id="validationErrorFeedback"
                              class="invalid-feedback d-block">
                              {{ value.validation[value.errorCode - 1].error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--end::Table wrapper-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'email'">
                      <!--begin::Title-->
                      <div class="d-flex flex-wrap gap-2 justify-content-between mb-8">
                        <div class="d-flex align-items-center flex-wrap gap-2">
                          <!--begin::Heading-->
                          <h2 class="fw-bold me-3 my-1">
                            {{ info["contactSubject"] }}
                          </h2>
                          <!--begin::Heading-->
                        </div>
                      </div>
                      <!--end::Title-->
                      <!--begin::Message accordion-->
                      <div data-kt-inbox-message="message_wrapper">
                        <!--begin::Message header-->
                        <div class="d-flex flex-wrap gap-2 flex-stack cursor-pointer">
                          <!--begin::Author-->
                          <div class="d-flex align-items-center">
                            <div class="pe-5">
                              <!--begin::Author details-->
                              <div class="d-flex align-items-center flex-wrap gap-1">
                                <a href="#" class="fw-bolder text-dark text-hover-primary">{{ info["contactFullName"]
                                }}</a>
                              </div>
                              <!--end::Author details-->
                            </div>
                          </div>
                          <!--end::Author-->
                          <!--begin::Actions-->
                          <div class="d-flex align-items-center flex-wrap gap-2">
                            <!--begin::Date-->
                            <span class="fw-bold text-muted text-end me-3">{{
                              info["contactDate"]
                            }}</span>
                            <!--end::Date-->
                          </div>
                          <!--end::Actions-->
                        </div>
                        <!--end::Message header-->
                        <!--begin::Message content-->
                        <div class="collapse fade show">
                          <div class="py-5 fst-italic fs-5">
                            {{ info["contactDescription"] }}
                          </div>
                        </div>
                        <!--end::Message content-->
                      </div>
                      <!--end::Message accordion-->
                      <div class="separator my-6"></div>
                      <!--begin::Form-->
                      <div class="d-flex justify-content-between">
                        <label v-if="field.title.length > 0" class="fs-5 fw-bolder form-label mb-3">
                          <span v-if="info['contactMark']" class="text-danger">{{ field.title }} has been sent</span>
                          <span v-else :class="field.required ? 'required' : ''">{{ field.title }}</span>
                        </label>
                      </div>
                      <form class="rounded" style="border: 1px solid #ccc">
                        <!--begin::Body-->
                        <div class="d-block">
                          <!--begin::To-->
                          <div style="border-bottom: 1px solid #ccc">
                            <a :href="`mailto: ${info['contactEmail']}`" dir="ltr"
                              class="form-control border-0 px-8 min-h-45px">{{ info["contactEmail"] }}</a>
                          </div>
                          <!--end::To-->
                          <!--begin::Subject-->
                          <div style="border-bottom: 1px solid #ccc">
                            <div class="form-control border-0 px-8 min-h-45px">
                              {{ info["contactSubject"] }}
                            </div>
                          </div>
                          <!--end::Subject-->
                          <div class="form-control border-0 px-8 min-h-45px" v-if="info['contactMark']">
                            {{ info["contactResponse"] }}
                          </div>
                          <textarea v-else class="form-control border-0 px-8 min-h-45px" :class="field.required && field.errorCode
                            ? 'wrong-inputs'
                            : ''
                            " rows="5" v-model="info['contactResponse']" :placeholder="field.placeholder">
                      </textarea>
                        </div>
                        <!--end::Body-->
                      </form>
                      <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                        class="invalid-feedback d-block">
                        {{ field.validation[field.errorCode - 1].error }}
                      </div>
                      <!--end::Form-->
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'ticket' && info.ticketSource != null">
                      <!--begin::Title-->
                      <div class="d-flex flex-column flex-wrap gap-2">
                        <!--begin::Heading-->
                        <h2 class="fw-bold me-3 my-1">
                          {{ info.ticketSource.ticketSubject }}
                        </h2>
                        <!--begin::User-->
                        <div class="d-flex align-items-center">
                          <!--begin::Details-->
                          <div class="">
                            <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{
                              info.ticketSource.ticketUser }}</a>
                            <span class="text-muted fs-7 mb-1">{{
                              info.ticketSource.ticketDate
                            }}</span>
                          </div>
                          <!--end::Details-->
                        </div>
                        <!--end::User-->
                        <!--begin::Heading-->
                        <div class="separator mb-5"></div>
                        <!--begin::Message-->
                        <div class="d-flex justify-content-start mb-10">
                          <!--begin::Wrapper-->
                          <div class="d-flex flex-column align-items-start">
                            <!--begin::Text-->
                            <div class="p-7 bg-light-primary text-dark fw-semibold mw-lg-400px text-start"
                              style="border-radius: 0 1rem 1rem 1rem" data-kt-element="message-text">
                              <div v-html="info.ticketSource.ticketMessage" class="fs-4"></div>
                              <!--begin::Attachments-->
                              <div v-if="
                                info.ticketSource.ticketAttachments.length > 0
                              " class="mt-20">
                                <span class="fs-7 text-primary">attachments</span>
                                <div class="separator mb-5 border-primary opacity-50"></div>
                                <div class="d-flex flex-wrap gap-3">
                                  <a v-for="(attach, index) in info.ticketSource
                                    .ticketAttachments" :key="index" class="d-block overlay cursor-pointer"
                                    @click="softBox(attach)">
                                    <div
                                      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-60px w-60px bg-secondary"
                                      :style="`
                              background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${attach});
                            `"></div>
                                    <!--begin::Action-->
                                    <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                                      <i class="bi bi-eye-fill fs-2x text-white"></i>
                                    </div>
                                    <!--end::Action-->
                                  </a>
                                </div>
                              </div>
                              <!--end::Attachments-->
                            </div>
                            <!--end::Text-->
                          </div>
                          <!--end::Wrapper-->
                        </div>
                        <!--end::Message-->
                      </div>
                      <!--end::Title-->
                      <div v-for="(history, index) in info.ticketHistory" :key="index">
                        <!--begin::Message(in)-->
                        <div v-if="
                          history['ticketUser'] ==
                          info['ticketSource']['ticketUser']
                        " class="d-flex justify-content-start mb-10">
                          <!--begin::Wrapper-->
                          <div class="d-flex flex-column align-items-start">
                            <!--begin::User-->
                            <div class="d-flex align-items-center mb-2">
                              <!--begin::Details-->
                              <div class="ms-3">
                                <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{
                                  history.ticketUser
                                }}</a>
                                <span class="text-muted fs-7 mb-1">{{
                                  history.ticketDate
                                }}</span>
                              </div>
                              <!--end::Details-->
                            </div>
                            <!--end::User-->
                            <!--begin::Text-->
                            <div class="p-7 bg-light-primary text-dark fw-semibold mw-lg-400px text-start"
                              style="border-radius: 0 1rem 1rem 1rem" data-kt-element="message-text">
                              <div v-html="history.ticketMessage" class="fs-4"></div>
                              <!--begin::Attachments-->
                              <div v-if="history.ticketAttachments.length > 0" class="mt-20">
                                <span class="fs-7 text-primary">attachments</span>
                                <div class="separator mb-5 border-primary opacity-50"></div>
                                <div class="d-flex flex-wrap gap-3">
                                  <a v-for="(
attach, index
                                    ) in history.ticketAttachments" :key="index" class="d-block overlay cursor-pointer"
                                    @click="softBox(attach)">
                                    <div
                                      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-60px w-60px bg-secondary"
                                      :style="`
                              background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${attach});
                            `"></div>
                                    <!--begin::Action-->
                                    <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                                      <i class="bi bi-eye-fill fs-2x text-white"></i>
                                    </div>
                                    <!--end::Action-->
                                  </a>
                                </div>
                              </div>
                              <!--end::Attachments-->
                            </div>
                            <!--end::Text-->
                          </div>
                          <!--end::Wrapper-->
                        </div>
                        <!--end::Message(in)-->
                        <!--begin::Message(out)-->
                        <div v-else class="d-flex justify-content-end mb-10">
                          <!--begin::Wrapper-->
                          <div class="d-flex flex-column align-items-end">
                            <!--begin::User-->
                            <div class="d-flex align-items-center mb-2">
                              <!--begin::Details-->
                              <div class="me-3">
                                <span class="text-muted fs-7 mb-1">{{
                                  history.ticketDate
                                }}</span>
                                <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">{{
                                  history.ticketUser
                                }}</a>
                              </div>
                              <!--end::Details-->
                            </div>
                            <!--end::User-->
                            <!--begin::Text-->
                            <div class="p-7 bg-primary text-white fw-semibold mw-lg-400px text-end"
                              style="border-radius: 1rem 0 1rem 1rem" data-kt-element="message-text">
                              <div v-html="history.ticketMessage" class="fs-4"></div>
                              <!--begin::Attachments-->
                              <div v-if="history.ticketAttachments.length > 0" class="mt-20">
                                <span class="fs-7 text-primary">attachments</span>
                                <div class="separator mb-5 border-primary opacity-50"></div>
                                <div class="d-flex flex-wrap gap-3">
                                  <a v-for="(
attach, index
                                    ) in history.ticketAttachments" :key="index" class="d-block overlay cursor-pointer"
                                    @click="softBox(attach)">
                                    <div
                                      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-60px w-60px bg-secondary"
                                      :style="`
                              background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${attach});
                            `"></div>
                                    <!--begin::Action-->
                                    <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                                      <i class="bi bi-eye-fill fs-2x text-white"></i>
                                    </div>
                                    <!--end::Action-->
                                  </a>
                                </div>
                              </div>
                              <!--end::Attachments-->
                            </div>
                            <!--end::Text-->
                          </div>
                          <!--end::Wrapper-->
                        </div>
                        <!--end::Message(out)-->
                      </div>
                    </div>
                    <div :tabindex="index" v-else-if="field.type == 'radioGroup'">
                      <div class="rounded border border-dashed p-10" :class="field.required && field.errorCode > 0
                        ? 'border-danger'
                        : ''
                        ">
                        <div v-for="(option, index) in field.options" :key="index" class="mb-5">
                          <div class="form-check">
                            <input class="form-check-input" :checked="option.value == info[field.name]" type="radio"
                              @click="setRadioGroup(field.name, option.value)" :id="`radiogroup${index}`"
                              :name="field.name" />
                            <label class="form-check-label" :for="`radiogroup${index}`">{{ option.title }}</label>
                          </div>
                        </div>
                        <div v-if="field.required && field.errorCode > 0" id="validationErrorFeedback"
                          class="invalid-feedback d-block">
                          {{ field.validation[field.errorCode - 1].error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Input group-->
              </div>
              <!--end::Scroll-->
            </form>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-center border-gray-300 shadow-lg">
          <div class="text-center">
            <button class="btn btn-light me-3" @click="closeModal">
              {{ contents.buttons ? contents.buttons[0].title : "Cancel" }}
            </button>
            <!-- <button v-if="generalStep == 0" class="btn btn-info me-3" @click="changeCustomStep('next')">
              Next Step
            </button>
            <button v-if="$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' && generalStep > 0" class="btn btn-info me-3" @click="changeCustomStep('previous')">
              Previous Step
            </button> -->
            <button v-if="!(contents.title == 'Uploads' && modalInfo.status) && generalStep == 1"
              class="btn btn-primary me-3" @click="closeModal('validate', info)">
              <span class="indicator-label">{{
                contents.buttons ? contents.buttons[1].title : "Save"
              }}</span>
            </button>
            <button v-if="
              contents.title == 'Ticket' &&
              modalInfo['ticketHistory'] &&
              modalInfo['ticketHistory'].length > 0
            " class="btn btn-danger me-3" @click="closeModal('validate', info)">
              <span class="indicator-label">{{
                contents.buttons ? contents.buttons[2].title : "Save"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--end::Modal dialog-->
    <upload-assets v-if="modalDisplay" :contents="null" :modalInfo="uploadInfo" :mode="mode" :modalType="modalType"
      @close-modal="setModalConfigs"></upload-assets>
    <select-template v-if="templateModalDisplay" :contents="null" :modalInfo="templateInfo"
      @close-modal="setModalConfigs"></select-template>
    <select-element v-if="elementsModalDisplay" :contents="null" :modalInfo="elementsModalInfo"
      @close-modal="setModalConfigs"></select-element>
    <config-element v-if="configElementModalDisplay" :contents="null" :modalInfo="elementModalInfo"
      @close-modal="setModalConfigs"></config-element>
    <!--end::Modals-->
    <div>
      <FsLightbox :toggler="toggler" :sources="[`${softBoxSource}`]" />
    </div>
  </div>
</template>

<script>
import UploadAssets from "../modals/UploadAssets.vue";
import SelectTemplate from "../modals/SelectTemplate.vue";
import SelectElement from "../modals/SelectElement.vue";
import ConfigElement from "../modals/ConfigElement.vue";
import Multiselect from "@vueform/multiselect";
import Editor from "@tinymce/tinymce-vue";
import Dropzone from "dropzone";
import DatePicker from "vue3-persian-datetime-picker";
// import VueDatePicker from '@vuepic/vue-datepicker';
import serverConfigs from "../../configs/server.json";
import dataService from "../../services/data";
import FsLightbox from "fslightbox-vue";
import JsonEditorVue from "json-editor-vue3";
// import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {
    UploadAssets,
    SelectTemplate,
    SelectElement,
    multiselect: Multiselect,
    editor: Editor,
    DatePicker,
    FsLightbox,
    ConfigElement,
    JsonEditorVue,
    // VueDatePicker
  },
  data() {
    return {
      shareType: "",
      hafezliNewObj: {
        curStep: '0',
        curTask: 0,
        steps: [
          {
            title: 'Basic info',
            name: 'basicInfo'
          },
          {
            title: 'Activity',
            name: 'chapterInfo',
            sessions: [
              {
                id: '1',
                title: 'Lead-in (Engage)',
                name: 'lead'
              },
              {
                id: '2',
                title: 'Task (Study)',
                name: 'tasks'
              },
              {
                id: '3',
                title: 'Follow-up (Activate)',
                name: 'followUp'
              }
            ]
          }
        ],
        teachers: [
          {
            value: "1",
            title: "استاد 1"
          }
        ],
        categories: [],
        tags: [],
        info: [
          {
            files: [],
            title: "",
            summary: "",
            price: "",
            teacher: "",
            category: "",
            tags: [],
            description: ""
          },
          {
            lead: {
              lock: true,
              title: "",
              summary: "",
              description: "",
              files: [],
              question: false,
              ansType: "",
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            },
            tasks: [{
              description: "",
              files: [],
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            }],
            followUp: {
              description: "",
              files: [],
              ansType: "",
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            }
          }
        ],
        objects: {
          quiz: [
            {
              title: "کلوز تست",
              value: "clozeTest",
            },
            {
              title: "جای خالی",
              value: "blank",
            },
            {
              title: "مچینگ",
              value: "matching",
            },
            {
              title: "پاسخ کوتاه",
              value: "shortAns",
            },
            {
              title: "پاسخ تشریحی",
              value: "longAns",
            },
            {
              title: "2 گزینه‌ای",
              value: "2choices",
            },
            {
              title: "3 گزینه‌ای",
              value: "3choices",
            },
            {
              title: "4 گزینه‌ای",
              value: "4choices",
            },
          ],
          general: [
            {
              title: "بازگذاری فایل (تصویر، ویدیو یا صوت)",
              value: "upload",
            },
            {
              title: "ویرایشگر متن",
              value: "blank",
            }
          ]
        },
        units: []
      },
      formInputsConfig: {
        general: [
          {
            name: "label",
            type: "text",
          },
          {
            name: "placeholder",
            type: "text",
          },
          {
            name: "tip",
            type: "summary",
          },
          {
            name: "required",
            type: "toggle",
          },
          {
            name: "conditions",
            type: "multiselect",
            options: [
              {
                label: "Check if the input is empty",
                value: "isEmpty",
              },
              {
                label: "Check if the input is just spaces",
                value: "isSpace",
              },
              {
                label: "Check if the input is just spaces",
                value: "isCorrectAnswer",
              },
              {
                label: "Check if the input is more than min length",
                value: "isMinLength",
              },
              {
                label: "Check if the input lower than max length",
                value: "isMaxLength",
              },
              {
                label: "Check if the input is just spaces",
                value: "isSpace",
              },
            ],
          },
        ],
        text: [
          {
            name: "mode",
            type: "combobox",
            options: [
              {
                label: "A sentence",
                value: "single",
              },
              {
                label: "A paragraph",
                value: "multi",
              },
              {
                label: "Text Editor",
                value: "editor",
              },
            ],
          },
          {
            name: "ui",
            type: "combobox",
            options: [
              {
                label: "Text Box",
                value: "text",
              },
              {
                label: "Textarea",
                value: "textarea",
              },
            ],
          },
          {
            vif: "isMinLength",
            name: "minLength",
            type: "tel",
          },
          {
            vif: "isMaxLength",
            name: "maxLength",
            type: "tel",
          },
        ],
        select: [],
        file: [],
      },
      hafezliWizardStep: "basicInfo",
      hafezliSessionNo: -1,
      hafezliCoursesObj: {
        courseAttachment: [],
        courseTitle: "",
        courseSummary: "",
        coursePrice: 0,
        courseTeacher: null,
        courseTeachers: [
          {
            value: 1,
            title: "استاد 1",
          },
          {
            value: 2,
            title: "استاد 2",
          },
          {
            value: 3,
            title: "استاد 3",
          },
          {
            value: 4,
            title: "استاد 4",
          },
        ],
        courseCategory: null,
        courseCategories: [
          {
            value: 1,
            title: "دسته بندی 1",
          },
          {
            value: 2,
            title: "دسته بندی 2",
          },
          {
            value: 3,
            title: "دسته بندی 3",
          },
          {
            value: 4,
            title: "دسته بندی 4",
          },
        ],
        courseTags: [],
        courseTagsList: [
          {
            value: 1,
            title: "برچسب 1",
          },
          {
            value: 2,
            title: "برچسب 2",
          },
          {
            value: 3,
            title: "برچسب 3",
          },
          {
            value: 4,
            title: "برچسب 4",
          },
        ],
        courseTopics: [
          {
            value: "listening",
            title: "شنیدار",
          },
          {
            value: "speaking",
            title: "مکالمه",
          },
          {
            value: "Writing",
            title: "نوشتار",
          },
          {
            value: "reading",
            title: "درک مطلب",
          },
        ],
        courseDescription: "",
        courseLeadObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
        ],
        courseTaskObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
          {
            title: "writing",
            value: "writing",
          },
          {
            title: "reading",
            value: "reading",
          },
          {
            title: "conversation",
            value: "conversation",
          },
        ],
        courseQuizObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
          {
            title: "text",
            value: "text",
          },
        ],
        courseQuizAnsOptions: [
          {
            title: "blank",
            value: "blank",
          },
          {
            title: "clozeTest",
            value: "clozeTest",
          },
          {
            title: "4choices",
            value: "4choices",
          },
          {
            title: "3choices",
            value: "3choices",
          },
          {
            title: "2choices",
            value: "2choices",
          },
          {
            title: "shortAns",
            value: "shortAns",
          },
          {
            title: "longAns",
            value: "longAns",
          },
          {
            title: "matching",
            value: "matching",
          },
        ],
        courseFollowupOptions: [
          {
            title: "upload",
            value: "upload",
          },
          {
            title: "blank",
            value: "blank",
          },
          {
            title: "table",
            value: "table",
          },
        ],
        courseQuizAnsObj: {
          question: "",
          type: "",
          ans: "",
          options: ["", "", "", "", "", "", "", "", "", ""],
          matchingOptions: [
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
          ],
        },
        courseQuizAnsTypes: [
          {
            title: "Image",
            value: "image",
          },
          {
            title: "Text",
            value: "text",
          },
        ],
        courseSessions: [],
        courseQuizForms: [],
      },
      hafezliSessionsObj: {
        sessionLock: "",
        sessionFramework: {
          lead: {
            summary: "",
            objType: "",
            form: 0,
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
            },
            ansStatus: true,
            userAns: "",
          },
          task: {
            summary: "",
            objType: "",
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
              text: "",
            },
            quiz: {
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              forms: [],
              form: 0,
            },
          },
          followup: {
            summary: "",
            objType: "",
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
              text: "",
            },
            ansType: "",
            form: 0,
            userAns: "",
          },
        },
      },
      temptime: null,
      vidisciObj: {
        step: 0,
        steps: [
          {
            name: "step0",
            title: "Choose template",
          },
          {
            name: "step1",
            title: "Create / Edit video",
          },
          {
            name: "step2",
            title: "Theme color",
          },
          {
            name: "step3",
            title: "Music / Soundtrack",
          },
          {
            name: "step4",
            title: "Preview & Render",
          }
        ],
        videoInfo: {}
      },
      tinyMCE_Def: {
        menubar: true,
        plugins: "lists link emoticons directionality",
        toolbar:
          "styleselect | bold italic | alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist | link emoticons",
        directionality: '',
        minHeight: 600,
      },
      inlineConfigDisplay: false,
      softBoxSource: "",
      focusStatus: false,
      pac: true,
      infoImage: {},
      infoElement: {},
      displayStatus: false,
      value: null,
      uploadInfo: {
        images: [],
        current: {},
      },
      groupItems: [],
      toggler: false,
      elementsModalInfo: {},
      elementModalInfo: {},
      elementsModalDisplay: false,
      configElementModalDisplay: false,
      modalDisplay: false,
      templateInfo: {},
      templateModalDisplay: false,
      dropzoneCounter: 0,
      info: {},
      verifyCode: "",
      verifyCodeErrorClass: "",
      verifyTime: true,
      countDown: 5,
      generalStep: 1,
      templateOption: {
        status: false
      }
    };
  },
  props: {
    hafezliUnits: {
      required: false,
    },
    routeLocale: {
      require: false,
    },
    stepType: {
      require: false,
    },
    contents: {
      required: true,
    },
    modalInfo: {
      required: false,
    },
    mode: {},
    modalType: {
      required: true,
    },
    enableTimer: {
      required: false,
    },
    firstErrorName: {
      required: false,
    },
    icons: {
      required: false,
    },
  },
  computed: {
    editorDirection() {
      if (['fa', 'ar'].indexOf(this.$route.params.locale) > -1) {
        return 'rtl'
      }
      return 'ltr'
    },
    routeFullPath() {
      return this.$route.fullPath.includes("myproducts");
    },
    hafezliCurStepIndex() {
      return this.hafezliNewObj.curStep.split('-')[0]
    },
    tinymceToken() {
      return serverConfigs["tinymceToken"];
    },
    inlineRouteLocale() {
      return this.$route.params.locale;
    },
    templateIndex() {
      let index = "";
      for (let b in this.contents.fields[0].options) {
        if (
          this.contents.fields[0].options[b].value == this.info["blogTemplate"]
        ) {
          index = b;
        }
      }
      console.log(index)
      return index;
    },
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    modalOverlay() {
      let elem = document.createElement("div");
      elem.style.cssText = "z-index:109";
      elem.classList.add("drawer-overlay");
      return elem;
    },
    modalNode() {
      return document.getElementsByClassName("modal fade")[0];
    },
    bodyNode() {
      return document.getElementById("kt_body");
    },
  },
  methods: {
    setMultiSelectedUpload(event, obj, name) {
      console.log(event.target.checked, obj, name)
      if (typeof this.info[name] == 'string') {
        this.info[name] = []
      }
      if (event.target.checked) {
        this.info[name].push(obj)
        // this.info["current"]["image"].push(imageName);
        // document
        //   .getElementById(`uploadImage_${imageName}`)
        //   .classList.add("active");
      } else {
        this.info[name].splice(
          this.info[name].indexOf(obj), 1
        )
        // this.info["current"]["image"].splice(
        //   this.info["current"]["image"].indexOf(imageName),
        //   1
        // );
        // document
        //   .getElementById(`uploadImage_${imageName}`)
        //   .classList.remove("active");
      }
    },
    collapseHafezliTask_New(index) {
      this.hafezliNewObj.curTask = index
    },
    changeHafezliStep_New(index) {
      this.hafezliNewObj.curStep = index;
      this.hafezliNewObj.curTask = 0;
    },
    changeHafezliTask_New(index) {
      this.hafezliNewObj.curTask = index;
    },
    addHafezliSteps_New(index) {
      this.hafezliNewObj.steps.splice(index + 1, 0, {
        title: 'Activity',
        name: 'chapterInfo',
        sessions: [
          {
            id: '1',
            title: 'Lead-in (Engage)',
            name: 'lead'
          },
          {
            id: '2',
            title: 'Task (Study)',
            name: 'tasks'
          },
          {
            id: '3',
            title: 'Follow-up (Activate)',
            name: 'followUp'
          }
        ]
      })
      this.hafezliNewObj.info.splice(index + 1, 0, {
        lead: {
          lock: true,
          title: "",
          summary: "",
          description: "",
          files: [],
          question: false,
          ansType: "",
        },
        tasks: [{
          description: "",
          files: [],
          quizes: [{
            type: "",
            question: "",
            summary: "",
            answerType: "text",
            answer: ["", "", "", "", "", "", "", "", "", ""],
            leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
          }]
        }],
        followUp: {
          description: "",
          files: [],
          ansType: "",
        }
      })
      console.log(this.hafezliNewObj.steps)
      console.log("Add step")
    },
    deleteHafezliSteps_New(index) {
      this.hafezliNewObj.curStep = '0';
      this.hafezliNewObj.steps.splice(index, 1)
      this.hafezliNewObj.info.splice(index, 1)
      console.log(this.hafezliNewObj.steps)
      console.log("Delete step")
    },
    addHafezliTask_New(index) {
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks.splice(index + 1, 0, {
        description: "",
        files: [],
        quizes: [{
          type: "",
          question: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        }]
      })
      console.log(this.hafezliNewObj.steps)
      console.log("Add task")
    },
    deleteHafezliTask_New(index) {
      this.hafezliNewObj.curTask = 0
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks.splice(index, 1)
      console.log("Delete task")
    },
    addHafezliQuiz_New(taskIndex, index) {
      if (taskIndex == 'lead' || taskIndex == 'followUp') {
        this.hafezliNewObj.info[this.hafezliCurStepIndex][taskIndex].quizes.splice(index + 1, 0, {
          type: "",
          question: "",
          summary: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        })
      } else {
        this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks[taskIndex].quizes.splice(index + 1, 0, {
          type: "",
          question: "",
          summary: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        })
      }
      console.log("Add quiz")
    },
    deleteHafezliQuiz_New(taskIndex, index) {
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks[taskIndex].quizes.splice(index, 1)
      console.log("Delete quiz")
    },
    createHafezliProduct_New() {
      console.log(this.hafezliNewObj.info)
      // this.hafezliNewObj.info = [
      //   {
      //     "files": [
      //       "1751222151600_SaminLogo.png"
      //     ],
      //     "title": "Test Package",
      //     "summary": "It's a test package",
      //     "price": 1500000,
      //     "teacher": "1",
      //     "category": 663,
      //     "tags": [
      //       130,
      //       188
      //     ],
      //     "description": "<p>Test 1 2 3 4</p>"
      //   },
      //   {
      //     "lead": {
      //       "lock": true,
      //       "title": "Chapter 1",
      //       "summary": "It's chapter 1 about PPT",
      //       "description": "",
      //       "files": [
      //         "1746889882047_English_Conversation_at_a_Cafe_Coffee_Shop_Useful_Phrases.mp4"
      //       ],
      //       "question": true,
      //       "ansType": "blank"
      //     },
      //     "tasks": [
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "2choices",
      //             "question": "",
      //             "summary": "It's a tip for quiz",
      //             "answerType": "blank",
      //             "answer": [
      //               "123",
      //               "456",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           },
      //           {
      //             "type": "clozeTest",
      //             "question": "",
      //             "summary": "It's a tip for you",
      //             "answerType": "text",
      //             "answer": [
      //               "1san",
      //               "w",
      //               "s",
      //               "a",
      //               "a",
      //               "a",
      //               "d",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           }
      //         ]
      //       },
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "longAns",
      //             "question": "",
      //             "answerType": "text",
      //             "answer": [
      //               "asdsdasdsad2312321",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "summary": "dsdsadsa2"
      //           }
      //         ]
      //       }
      //     ],
      //     "followUp": {
      //       "description": "",
      //       "files": [
      //         "1746525518325_“23SecretsBaristasatSmallCoffeeShopsWon’t….jpg"
      //       ],
      //       "ansType": "blank"
      //     }
      //   },
      //   {
      //     "lead": {
      //       "lock": true,
      //       "title": "Chapter 2",
      //       "summary": "Chapter 2 summary",
      //       "description": "",
      //       "files": [
      //         "1744790273661_controlpractice.mp4"
      //       ],
      //       "question": false,
      //       "ansType": ""
      //     },
      //     "tasks": [
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "matching",
      //             "question": "",
      //             "summary": "Talk abot it",
      //             "answerType": "text",
      //             "answer": [
      //               "w",
      //               "e",
      //               "4",
      //               "3",
      //               "a",
      //               "4",
      //               "d",
      //               "d",
      //               "d",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "12",
      //               "asdasd",
      //               "dsfdfd",
      //               "asdsa",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           }
      //         ]
      //       }
      //     ],
      //     "followUp": {
      //       "description": "",
      //       "files": [
      //         "1751222151600_SaminLogo.png"
      //       ],
      //       "ansType": "upload"
      //     }
      //   }
      // ]
      if (this.modalInfo.id) {
        this.hafezliNewObj["id"] = this.modalInfo.id;
      }
      this.closeModal("validate", this.hafezliNewObj);
    },
    hafezliCreateObj() {
      if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "matching"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = [{ q: "", a: "" }];
      } else if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "4choices"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = ["", "", ""];
      } else if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "truefalse"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = [""];
      }
    },
    handleBtnClick(opt, arrObj, index) {
      if (opt == "add") {
        arrObj.push(index);
      } else {
        arrObj.splice(index, 1);
      }
    },
    setVidisciStep(index) {
      this.vidisciObj.step = index;
    },
    showSessions() {
      // this.hafezliCoursesObj = {
      //   courseAttachment: [],
      //   courseTitle: "دوره ۱",
      //   courseSummary: "خلاصه دوره ۱",
      //   coursePrice: 0,
      //   courseTeacher: 1,
      //   courseTeachers: [
      //     {
      //       value: 1,
      //       title: "استاد 1",
      //     },
      //     {
      //       value: 2,
      //       title: "استاد 2",
      //     },
      //     {
      //       value: 3,
      //       title: "استاد 3",
      //     },
      //     {
      //       value: 4,
      //       title: "استاد 4",
      //     },
      //   ],
      //   courseCategory: 1,
      //   courseCategories: [
      //     {
      //       value: 1,
      //       title: "دسته بندی 1",
      //     },
      //     {
      //       value: 2,
      //       title: "دسته بندی 2",
      //     },
      //     {
      //       value: 3,
      //       title: "دسته بندی 3",
      //     },
      //     {
      //       value: 4,
      //       title: "دسته بندی 4",
      //     },
      //   ],
      //   courseTags: [1, 2],
      //   courseTagsList: [
      //     {
      //       value: 1,
      //       title: "برچسب 1",
      //     },
      //     {
      //       value: 2,
      //       title: "برچسب 2",
      //     },
      //     {
      //       value: 3,
      //       title: "برچسب 3",
      //     },
      //     {
      //       value: 4,
      //       title: "برچسب 4",
      //     },
      //   ],
      //   courseTopics: [
      //     {
      //       value: "listening",
      //       title: "شنیدار",
      //     },
      //     {
      //       value: "speaking",
      //       title: "مکالمه",
      //     },
      //     {
      //       value: "Writing",
      //       title: "نوشتار",
      //     },
      //     {
      //       value: "reading",
      //       title: "درک مطلب",
      //     },
      //   ],
      //   courseAnswerTypes: [
      //     {
      //       value: "4choices",
      //       title: "4 گزینه‌ای",
      //     },
      //     {
      //       value: "truefalse",
      //       title: "درست / نادرست",
      //     },
      //     {
      //       value: "short",
      //       title: "پاسخ کوتاه",
      //     },
      //     {
      //       value: "long",
      //       title: "تشریحی",
      //     },
      //   ],
      //   courseDescription: "",
      //   courseSessions: [
      //     {
      //       sessionLock: "",
      //       sessionType: "teaching",
      //       sessionTopic: "",
      //       sessionTitle: "جلسه ۱",
      //       sessionSummary: "خلاصه جلسه ۱",
      //       sessionPassPoint: "",
      //       sessionDuration: "",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionDescription: "",
      //     },
      //     {
      //       sessionLock: "",
      //       sessionType: "quiz",
      //       sessionTopic: "listening",
      //       sessionTitle: "کوییز ۱",
      //       sessionSummary: "سوال کوییز ۱",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionChoices: ["نادرست"],
      //       sessionAnswerType: "truefalse",
      //       sessionPassPoint: 10,
      //       sessionDuration: 45,
      //       sessionDescription: "توضیحات و نکات کوییز ۱",
      //     },
      //     {
      //       sessionLock: "",
      //       sessionType: "homework",
      //       sessionTopic: "",
      //       sessionTitle: "تمرین ۱",
      //       sessionSummary: "متن تمرین ۱",
      //       sessionPassPoint: "",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionDuration: 1,
      //       sessionDescription: "پاسخ خود را آ\\لود کنید",
      //     },
      //   ],
      // };
      if (this.modalInfo.id) {
        this.hafezliCoursesObj["id"] = this.modalInfo.id;
      }
      // console.log(this.hafezliCoursesObj)
      this.closeModal("validate", this.hafezliCoursesObj);
    },
    setSessionType(type) {
      this.hafezliWizardStep = "sessionInfo";
      this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
        "sessionType"
      ] = type;
    },
    nextSession() {
      this.hafezliSessionNo += 1;
      this.hafezliWizardStep = "lead";
    },
    addGroupItem(event, item, index) {
      if (event.target.checked) {
        this.groupItems.push({ ...item, index: index });
      } else {
        this.groupItems.splice(
          this.groupItems.indexOf({ ...item, index: index }),
          1
        );
      }
      console.log(this.groupItems);
    },
    groupingItems() {
      let cardFields = [];
      let cardDefault = {};
      let cardJson = {
        name: "cardItems",
        title: "Group Items",
        type: "card",
        required: false,
        default: {},
        value: {},
        count: 1,
        fields: [],
        editable: true,
        sortable: true,
        searchable: true,
        filterable: true,
        showable: true,
      };

      for (let i in this.groupItems) {
        cardFields.push(
          this.info["sectionJson"]["fields"][this.groupItems[i]["index"] - i]
        );
        cardDefault[this.groupItems[i]["name"]] =
          this.info["sectionJson"]["fields"][this.groupItems[i]["index"] - i][
          "default"
          ];
        this.info["sectionJson"]["fields"].splice(
          this.groupItems[i]["index"] - i,
          1
        );
        delete this.info["sectionJson"]["default"][this.groupItems[i]["name"]];

        this.info["sectionElements"][this.groupItems[i]["index"]][
          "grouped"
        ] = true;
        this.info["sectionElements"][this.groupItems[i]["index"]]["groupName"] =
          cardJson["name"];
      }

      cardJson.fields = cardFields;
      cardJson.default = [cardDefault];
      console.log(cardJson);

      this.info["sectionJson"]["fields"].push(cardJson);
      this.info["sectionJson"]["default"][cardJson["name"]] = [cardDefault];
    },
    async mergeElementJson(el, elName) {
      let tempEl = {};
      Object.assign(tempEl, {
        id: el["id"],
        name: elName,
        json: el["elementJson"],
        properties: el["elementProperties"],
      });

      let tempJson = {};
      for (let j in tempEl["json"]) {
        tempJson[j] = tempEl["json"][j]["value"];

        if (j == "name") {
          tempJson["name"] = tempEl["name"];
        }
      }

      for (let j in tempEl["properties"]) {
        tempJson[j] = tempEl["properties"][j]["value"];
      }

      return tempJson;
    },
    previousSession() {
      this.hafezliSessionNo -= 1;
      this.hafezliWizardStep = "sessionInfo";
    },
    addNewSession() {
      if (
        this.hafezliSessionNo ==
        this.hafezliCoursesObj.courseSessions.length - 1
      ) {
        let tempSessionObj = {};
        // Object.assign(tempSessionObj, this.hafezliSessionsObj);
        Object.assign(tempSessionObj, {
          sessionLock: "",
          sessionFramework: {
            lead: {
              summary: "",
              objType: "",
              form: 0,
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
              },
              ansStatus: true,
              userAns: "",
            },
            task: {
              summary: "",
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              quiz: {
                objType: "",
                obj: {
                  headers: ["", "", "", "", ""],
                  records: {
                    row1: ["", "", "", "", ""],
                    row2: ["", "", "", "", ""],
                    row3: ["", "", "", "", ""],
                    row4: ["", "", "", "", ""],
                    row5: ["", "", "", "", ""],
                  },
                  file: [],
                  text: "",
                },
                forms: [],
                form: 0,
              },
            },
            followup: {
              summary: "",
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              ansType: "",
              form: 0,
              userAns: "",
            },
          },
        });
        this.hafezliCoursesObj.courseSessions.push(tempSessionObj);
      }

      this.hafezliSessionNo += 1;
      this.hafezliWizardStep = "lead";
    },
    nextPart() {
      if (this.hafezliWizardStep == "lead") {
        this.hafezliWizardStep = "task";
      } else if (this.hafezliWizardStep == "task") {
        this.hafezliWizardStep = "followup";
      }
    },
    previousPart() {
      if (this.hafezliWizardStep == "task") {
        this.hafezliWizardStep = "lead";
      } else if (this.hafezliWizardStep == "followup") {
        this.hafezliWizardStep = "task";
      }
    },
    hafezliBlankQuizSymbole(question) {
      let tempLen = question.length;
      if (tempLen > 3) {
        if (question[tempLen - 3] == "_" && question[tempLen - 1] == "_") {
          this.hafezliAddQuiz();
        }
      }
    },
    hafezliAddQuiz() {
      let tempQuziAnsObj = {};
      Object.assign(tempQuziAnsObj, {
        question: "",
        type: "",
        ans: "",
        ansType: "",
        options: ["", "", "", "", "", "", "", "", "", ""],
        matchingOptions: [
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
        ],
        userAns: "",
      });
      console.log(tempQuziAnsObj);
      this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
        "sessionFramework"
      ][this.hafezliWizardStep]["quiz"]["forms"].push(tempQuziAnsObj);
    },
    deleteSession() {
      this.hafezliCoursesObj.courseSessions.splice(this.hafezliSessionNo, 1);
      if (this.hafezliSessionNo == 0) {
        this.hafezliWizardStep = "basicInfo";
      }
      this.hafezliSessionNo -= 1;
    },
    editPreviousSession() {
      this.hafezliSessionNo -= 1;

      this.hafezliWizardStep =
        this.hafezliSessionNo == -1 ? "basicInfo" : "chooseSessionType";
    },
    fetchIcons(query) {
      if (query) {
        return this.icons.filter((icon) => icon.title.includes(query));
      }

      return this.icons;
    },
    changeOrder(array, index, direction) {
      let temp = "";
      switch (direction) {
        case "up":
          temp = array[index];
          array[index] = array[index - 1];
          array[index - 1] = temp;
          break;
        case "down":
          temp = array[index];
          array[index] = array[index + 1];
          array[index + 1] = temp;
          break;
        default:
          break;
      }
    },
    chooseRow(event, root, value) {
      for (let item in this.info[root][value.name]) {
        this.info[root][value.name][item] = event.target.checked;
      }
    },
    addChild(root, index, key, child, rootIndex) {
      if (rootIndex) {
        let temp = {};
        for (let field in rootIndex.fields) {
          if (rootIndex.fields[field].type == "card") {
            let t = {};
            Object.assign(
              t,
              rootIndex.fields[field].value ? rootIndex.fields[field].value : ""
            );
            temp[rootIndex.fields[field].name] = [t];
          } else {
            temp[rootIndex.fields[field].name] = rootIndex.fields[field].value;
          }
        }

        if (temp) {
          this.info[root].push(temp);
        }
      } else {
        let temp = {};
        if (key) {
          Object.assign(temp, child);
          this.info[root][index][key].push(temp);
        } else {
          let tempRoot = {};
          for (let i in this.contents.fields[6].fields) {
            switch (this.contents.fields[6].fields[i].type) {
              case "text":
                tempRoot[this.contents.fields[6].fields[i].name] = "";
                break;
              case "textarea":
                tempRoot[this.contents.fields[6].fields[i].name] = "";
                break;
              case "card":
                Object.assign(temp, child);

                tempRoot[this.contents.fields[6].fields[i].name] = [temp];
                break;
              default:
                break;
            }
          }
          this.info[root].push(tempRoot);
        }
      }
    },
    delChild(root, index, key) {
      key ? this.info[root][index][key].pop() : this.info[root].pop();
      // if (this.$route.path.includes("contents")) {
      //   key
      //     ? this.info[root][index][key].pop()
      //     : this.info[root].splice(index - 3, 1);
      // } else {
      //   key ? this.info[root][index][key].pop() : this.info[root].pop();
      // }
    },
    addComponentChild(obj, child) {
      let temp = {};
      Object.assign(temp, child);
      obj.push(temp);
    },
    delComponentChild(obj, index) {
      obj.splice(index);
      // if (this.$route.path.includes("contents")) {
      //   key
      //     ? this.info[root][index][key].pop()
      //     : this.info[root].splice(index - 3, 1);
      // } else {
      //   key ? this.info[root][index][key].pop() : this.info[root].pop();
      // }
    },
    setOfset(field) {
      let modalEl = document.getElementById("kt_modal_add_role_scroll");
      modalEl.scroll(0, 20 * field.options.length);
      modalEl.style.overflow = "hidden";
    },
    inlineEditConfigs(el) {
      el["editMode"] = !el["editMode"];
    },
    setModalConfigs(opt, index) {
      switch (opt) {
        case "elementSettings":
          this.elementModalInfo = {
            ...this.info["sectionElements"][index],
            index: index,
          };
          this.configElementModalDisplay = true;
          break;
        case "elementSetting": {
          let tempJson1 = {};
          for (let j in index["json"]) {
            tempJson1[j] = index["json"][j]["value"];
          }

          for (let j in index["properties"]) {
            tempJson1[j] = index["properties"][j]["value"];
          }

          if (index["grouped"]) {
            console.log("Here");
          } else {
            this.info["sectionJson"]["fields"][index["index"]] = tempJson1;

            let defKeys1 = Object.keys(this.info["sectionJson"]["default"]);
            this.info["sectionJson"]["default"][defKeys1[index["index"]]] =
              tempJson1["default"];
          }

          this.configElementModalDisplay = false;
          break;
        }
        case "element":
          this.elementsModalDisplay = false;
          if (index["status"] == "create") {
            let defKeys = Object.keys(this.info["sectionJson"]["default"]);
            let elName = `${index["element"]["elementName"]}_1`;

            if (defKeys.length > 0 && defKeys.indexOf(elName) > -1) {
              let elNamePre = index["element"]["elementName"];
              let elIndex = 0;
              for (let i in defKeys) {
                if (String(defKeys[i]).includes(elNamePre)) {
                  elIndex = i;
                }
              }

              let elNameTemp = String(defKeys[elIndex]).split("_");
              elNameTemp = Number(elNameTemp[elNameTemp.length - 1]) + 1;
              elName = `${index["element"]["elementName"]}_${String(
                elNameTemp
              )}`;
            }
            index["element"]["elementProperties"];

            let tempEl = {};
            Object.assign(tempEl, {
              id: index["element"].id,
              // name: index['element']['elementName'],
              name: elName,
              json: index["element"]["elementJson"],
              properties: index["element"]["elementProperties"],
            });

            let tempJson = {};
            for (let j in tempEl["json"]) {
              tempJson[j] = tempEl["json"][j]["value"];

              if (j == "name") {
                tempJson["name"] = tempEl["name"];
              }
            }

            for (let j in tempEl["properties"]) {
              tempJson[j] = tempEl["properties"][j]["value"];
            }

            this.info["sectionElements"].push(tempEl);
            this.info["sectionJson"]["fields"].push(tempJson);
            this.info["sectionJson"]["default"][`${tempEl["name"]}`] =
              tempJson["default"];
          }
          console.log(this.info);
          break;
        case "elements":
          this.readElements(index);
          break;
        case "templates":
          this.templateInfo = {
            value: this.info[index.value] ? this.info[index.value] : "",
            category: index.category,
            field: index.value,
          };
          this.templateModalDisplay = !this.templateModalDisplay;
          break;
        case "template":
          this.templateInfo = {};
          this.info[index.field] = index.template;
          this.templateModalDisplay = !this.templateModalDisplay;
          break;
        case "choose":
          this.infoImage = index;

          this.getUploads();
          break;
        case "select":
          this.info.templateJson.fields[0].value = index;
          this.modalDisplay = !this.modalDisplay;
          break;
        case "update":
          this.roleInfo = { ...this.roles[index], status: true };
          this.roleInfo.rolePermissions = JSON.parse(
            this.roleInfo.rolePermissions
          );
          this.modalDisplay = !this.modalDisplay;
          break;
        case "create":
          this.setupRoleInfo();
          this.modalDisplay = !this.modalDisplay;
          break;
        case "validate":
          if (this.inputValidation(index)) {
            index.id ? this.updateRoles(index) : this.createRoles(index);
          }
          break;
        case "photo":
          if (this.stepType == "wizard") {
            if (this.infoImage.depth == 0) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.root] = index.image;
            } else if (this.infoImage.depth == 1) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.child][this.infoImage.root] = index.image;
            } else if (this.infoImage.depth == 2) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.child][this.infoImage.childIndex][this.infoImage.root] = index.image;
            }
            console.log(this.hafezliNewObj.info)
            // if (this.infoImage.subIndex && this.infoImage.subIndex == "forms") {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["quiz"]["forms"][this.infoImage.depth][
            //     "options"
            //   ][this.infoImage.subDepth] = index.image;
            // } else if (this.infoImage.depth == 0) {
            //   this.hafezliCoursesObj[this.infoImage.root] = index.image;
            // } else if (this.infoImage.name == "quiz") {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["quiz"]["obj"]["file"] = index.image;
            // } else {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["obj"]["file"] = index.image;
            //   // this.hafezliCoursesObj[this.infoImage.root][this.infoImage.index][
            //   //   this.infoImage.name] = index.image;
            // }
            this.modalDisplay = !this.modalDisplay;
          } else {
            if (
              this.infoImage &&
              this.infoImage.depth &&
              this.infoImage.depth == 5
            ) {
              this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
              ][this.infoImage["childIndex"]][this.infoImage["grandchild"]] =
                index.image;
            } else if (
              this.infoImage &&
              this.infoImage.depth &&
              this.infoImage.depth == 3
            ) {
              this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
              ] = index.image[0];
              console.log(
                this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
                ]
              );
            } else if (this.infoImage) {
              this.info[this.infoImage["root"]] = index.image;
              this.info["photos"] = index.image;
            } else {
              this.info["photos"] = index.image;
            }
            this.modalDisplay = !this.modalDisplay;
            if (this.contents.title == "Uploads" && this.modalInfo.status) {
              this.closeModal();
            }
          }
          break;
        default:
          this.modalDisplay = false;
          this.elementsModalDisplay = false;
          this.configElementModalDisplay = false;
          this.templateModalDisplay = false;
          if (this.contents.title == "Uploads" && this.modalInfo.status) {
            this.closeModal();
          }
          break;
      }
    },
    closeModal(opt, index) {
      this.focusStatus = false;
      this.$emit(
        "close-modal",
        opt && opt.length > 0 ? opt : null,
        index ? index : null,
        document.getElementById("dropzoneFiles") &&
          document.getElementById("dropzoneFiles").value &&
          document.getElementById("dropzoneFiles").value.length > 0
          ? document.getElementById("dropzoneFiles").value
          : null
      );
      if (
        document.getElementById("dropzoneFiles") &&
        document.getElementById("dropzoneFiles").value &&
        document.getElementById("dropzoneFiles").value.length > 0
      ) {
        document.getElementById("dropzoneFiles").value = "";
        const id = "#kt_dropzonejs_example_2";
        const dropzone = document.querySelector(id);
        dropzone.querySelector(".dropzone-remove-all").click();
      }
    },
    dropzoneInput() {
      // set the dropzone container id
      const id = "#kt_dropzonejs_example_2";
      const dropzone = document.querySelector(id);

      if (dropzone) {
        // set the preview element template
        var previewNode = dropzone.querySelector(".dropzone-item");
        previewNode.id = "";
        var previewTemplate = previewNode.parentNode.innerHTML;
        previewNode.parentNode.removeChild(previewNode);

        var myDropzone = new Dropzone(id, {
          // Make the whole body a dropzone
          url: `${serverConfigs["serverDomain"]["host"]}/api/v1/uploads/upload?locale=en`, // Set the url for your upload script location
          parallelUploads: 20,
          previewTemplate: previewTemplate,
          maxFilesize: 1000, // Max filesize in MB
          autoQueue: false, // Make sure the files aren't queued until manually added
          previewsContainer: id + " .dropzone-items", // Define the container to display the previews
          clickable: id + " .dropzone-select", // Define the element that should be used as click trigger to select files.
          acceptedFiles: "image/*",
          capture: "camera",
        });

        if (
          "mediaDevices" in navigator &&
          "getUserMedia" in navigator.mediaDevices
        ) {
          console.log("Let's get this party started");
        }

        myDropzone.on("addedfile", function (file) {
          // document
          //   .getElementById("photoPreview")
          //   .setAttribute("src", file.dataURL);
          // Hookup the start button
          file.previewElement.querySelector(
            id + " .dropzone-start"
          ).style.display = "none";

          const dropzoneItems = dropzone.querySelectorAll(".dropzone-item");
          dropzoneItems.forEach((dropzoneItem) => {
            dropzoneItem.style.display = "";
          });
          dropzone.querySelector(".dropzone-upload").style.display =
            "inline-block";
          dropzone.querySelector(".dropzone-remove-all").style.display =
            "inline-block";
          dropzone.querySelector(".dropzone-photo-delete").style.display =
            "none";
        });

        myDropzone.on("thumbnail", function (file, dataURL) {
          document.getElementById("photoPreview").setAttribute("src", dataURL);
        });
        // Update the total progress bar
        myDropzone.on("totaluploadprogress", function (progress) {
          const progressBars = dropzone.querySelectorAll(".progress-bar");
          progressBars.forEach((progressBar) => {
            progressBar.style.width = progress + "%";
          });
        });

        myDropzone.on("sending", function (file) {
          // Show the total progress bar when upload starts
          const progressBars = dropzone.querySelectorAll(".progress-bar");
          progressBars.forEach((progressBar) => {
            progressBar.style.opacity = "1";
          });
          // And disable the start button
          file.previewElement
            .querySelector(id + " .dropzone-start")
            .setAttribute("disabled", "disabled");
        });

        myDropzone.on("success", function (file) {
          let temp =
            document.getElementById("dropzoneFiles").value.length > 0
              ? JSON.parse(document.getElementById("dropzoneFiles").value)
              : [];
          temp.push(JSON.parse(file.xhr.response)[0].filename);
          document.getElementById("dropzoneFiles").value = JSON.stringify(temp);
        });

        // Hide the total progress bar when nothing's uploading anymore
        myDropzone.on("complete", function () {
          const progressBars = dropzone.querySelectorAll(".dz-complete");

          setTimeout(function () {
            progressBars.forEach((progressBar) => {
              progressBar.querySelector(".progress-bar").style.display = "none";
              progressBar.querySelector(".progress").style.display = "none";
              progressBar.querySelector(".dropzone-start").style.display =
                "none";
            });
          }, 300);
        });

        // Setup the buttons for all transfers
        dropzone
          .querySelector(".dropzone-upload")
          .addEventListener("click", function () {
            myDropzone.enqueueFiles(
              myDropzone.getFilesWithStatus(Dropzone.ADDED)
            );
          });

        // Setup the button for remove all files
        dropzone
          .querySelector(".dropzone-remove-all")
          .addEventListener("click", function () {
            dropzone.querySelector(".dropzone-upload").style.display = "none";
            dropzone.querySelector(".dropzone-remove-all").style.display =
              "none";
            dropzone.querySelector(".dropzone-photo-delete").style.display =
              "inline-block";
            myDropzone.removeAllFiles(true);
          });

        // On all files completed upload
        myDropzone.on("queuecomplete", function () {
          const uploadIcons = dropzone.querySelectorAll(".dropzone-upload");
          uploadIcons.forEach((uploadIcon) => {
            uploadIcon.style.display = "none";
          });
          dropzone.querySelector(".dropzone-photo-delete").style.display =
            "inline-block";
        });

        // On all files removed
        myDropzone.on("removedfile", function () {
          if (myDropzone.files.length < 1) {
            dropzone.querySelector(".dropzone-upload").style.display = "none";
            dropzone.querySelector(".dropzone-remove-all").style.display =
              "none";
            dropzone.querySelector(".dropzone-photo-delete").style.display =
              "inline-block";
          }
        });
      }
    },
    readElements(element) {
      let data = {
        endPoint: `elements`,
        pageNo: "",
        locale: `fa`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let elements = res.data.data;
          for (let i in elements) {
            elements[i].elementDate = new Date(
              elements[i].elementDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            elements[i].elementPhotos = elements[i].elementPhotos.split(",");
          }
          this.elementsModalInfo = {
            elements: elements,
            element: element,
            value: element.id,
            status: element.id == 0 ? "create" : "update",
          };
          this.elementsModalDisplay = true;
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        });
    },
    getUploads() {
      let data = {
        endPoint: `uploads`,
        locale: "fa",
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        // query: {
        //   type: "blog",
        // },
      };
      // data.query = JSON.stringify(data.query)
      //   .replace("{", "")
      //   .replace(",", "&")
      //   .replace("}", "")
      //   .replace(/":"/g, "=")
      //   .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          this.uploadInfo = {
            images: res.data.data.reverse(),
            current: {
              upload: [],
            },
          };
          let tempImage = [];
          let tempIndex = [];
          let tempUpload = [];
          // let tempPhotos =
          //   this.infoImage && this.infoImage["root"]
          //     ? this.info[this.infoImage["root"]]
          //     : [];
          let tempPhotos = [];
          for (let j in this.info.photos ||
            this.info.sliderSlides ||
            tempPhotos) {
            for (let i in this.uploadInfo.images) {
              if (
                (this.info.photos &&
                  this.uploadInfo.images[i].uploadName ==
                  this.info.photos[j]) ||
                (this.info.sliderSlides &&
                  this.uploadInfo.images[i].uploadName ==
                  this.info.sliderSlides[j]) ||
                (tempPhotos &&
                  this.uploadInfo.images[i].uploadName == tempPhotos[j])
              ) {
                tempIndex.push(this.info.id);
                tempImage.push(this.uploadInfo.images[i].uploadName);
                tempUpload.push(Number(i));
                break;
              }
            }
          }
          this.uploadInfo.current = {
            index: tempIndex,
            image: tempImage,
            upload: tempUpload,
          };
          this.modalDisplay = true;
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        });
    },
    detectTabKey() {
      //
      // if (e.keyCode == 9) {
      //   let activeElem = document.activeElement;
      // }
    },
    setSelectedUpload(index, option) {
      this.info["blogTemplate"] = index;

      if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
        this.templateOption = option
        this.templateOption['status'] = true
      }
    },
    setRadioGroup(name, value) {
      this.info[name] = value;
    },
    deleteFilePhoto(index) {
      this.info[index] = "";
      let avatar = `${this.backendHost}/uploads/${this.$store.state.uploadsPath}/1616284800000_Avatar.png`;
      document.getElementById("photoPreview").setAttribute("src", avatar);
    },
    countDownTimer() {
      if (this.countDown == 0) {
        this.verifyTimerSwitch();
      } else {
        if (this.countDown > 0) {
          setTimeout(() => {
            this.countDown -= 1;
            this.countDownTimer();
          }, 1000);
        }
      }
    },
    softBox(src) {
      this.softBoxSource = `${this.backendHost}/uploads/${this.$store.state.uploadsPath}/${src}`;
      this.toggler = !this.toggler;
    },
    verifyTimerSwitch() {
      this.verifyTime = !this.verifyTime;
    },
    goto() {
      if (this.firstErrorName && this.firstErrorName.length > 0) {
        this.$refs[this.firstErrorName][0].scrollIntoView({
          behavior: "smooth",
        });
        if (
          !this.focusStatus &&
          this.$refs[`${this.firstErrorName}_Input`] &&
          this.$refs[`${this.firstErrorName}_Input`].length > 0
        ) {
          this.$refs[`${this.firstErrorName}_Input`][0].focus();
          this.focusStatus = true;
        }
      }
    },
    nestedAccordion(parentId, accordionId) {
      console.log(parentId);
      console.log(accordionId);
      let children = document.querySelectorAll(
        `[data-bs-parent='#${parentId}']`
      );
      children.forEach((element) => {
        element.classList.remove("show");
        if (`#${element.id}` != accordionId) {
          console.log(accordionId);
          console.log(element.id);

          console.log(document.getElementById(`${element.id}_button`));
          document
            .getElementById(`${element.id}_button`)
            .classList.add("collapsed");
        }
      });
      // for(let child in childs){
      //   console.log(childs[child].id)
      //   console.log(document.querySelector(`[data-bs-target='#${childs[child].id}']`))
      //     childs[child].classList.remove('show')
      //   // if(childs[child].id != accordionId){
      //   //   document.querySelectorAll(`[data-bs-target='#${childs[child].id}']`)[0].classList.add('collapsed')
      //   //   // document.querySelectorAll(`[data-bs-target='#${childs[child].id}']`)[1].classList.add('collapsed')
      //   // }
      // }
    },
    createVidisciVideo() {
      console.log("VidiSci Save Function")
    },
    changeCustomStep(status, index) {
      if (status == 'next') {
        this.generalStep += 1;
      } else if (status == 'previous') {
        this.generalStep -= 1;
      } else {
        this.generalStep = index;
      }
    },
  },
  mounted() {
    this.tinyMCE_Def.directionality = this.editorDirection
    if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' && this.contents.title == "Video") {
      this.generalStep = 0
    }
    // if (this.dropzoneCounter == 0) {
    //   this.dropzoneInput();
    //   this.dropzoneCounter += 1;
    // }
    if (this.stepType && this.stepType == "wizard") {
      this.hafezliNewObj.categories = this.contents.fields[4].options
      this.hafezliNewObj.tags = this.contents.fields[5].options
    }
    if (this.stepType && this.stepType == "wizard" && !this.modalInfo.status) {
      this.hafezliNewObj.info = []
      this.hafezliNewObj.info.push({
        files: this.modalInfo.productPhotos,
        title: this.modalInfo.productName,
        summary: this.modalInfo.productSummary,
        price: this.modalInfo.productPrice,
        teacher: "",
        category: this.modalInfo.productCategory,
        tags: this.modalInfo.productTags,
        description: this.modalInfo.productReview
      })

      for (let i in this.modalInfo.productChapters) {
        this.hafezliNewObj.info.push(this.modalInfo.productChapters[i])

        if (i > 0) {
          this.hafezliNewObj.steps.push({
            title: 'فصل',
            name: 'chapterInfo',
            sessions: [
              {
                id: '1',
                title: 'بخش Lead',
                name: 'lead'
              },
              {
                id: '2',
                title: 'بخش Tasks',
                name: 'tasks'
              },
              {
                id: '3',
                title: 'بخش Follow up',
                name: 'followUp'
              }
            ]
          })
        }
      }

      console.log(this.hafezliNewObj)
      // this.hafezliCoursesObj.courseAttachment = this.modalInfo.productPhotos;
      // this.hafezliCoursesObj.courseTitle = this.modalInfo.productName;
      // this.hafezliCoursesObj.courseSummary = this.modalInfo.productSummary;
      // this.hafezliCoursesObj.courseCategory = this.modalInfo.productCategory;
      // this.hafezliCoursesObj.courseTags = this.modalInfo.productTags;
      // this.hafezliCoursesObj.coursePrice = this.modalInfo.productPrice;
      // this.hafezliCoursesObj.courseDescription = this.modalInfo.productReview;
      // this.hafezliCoursesObj.courseSessions = this.info.status
      //   ? []
      //   : this.modalInfo.productChapters;
    }
    Object.assign(this.info, this.modalInfo);

    document.body.appendChild(this.modalOverlay);
    this.displayStatus = true;

    if (this.info.status) {
      for (let field in this.contents.fields) {
        if (
          this.contents.fields[field].type == "array" ||
          this.contents.fields[field].type == "component" ||
          this.contents.fields[field].type == "paragraph" ||
          this.contents.fields[field].type == "multiselect" ||
          this.contents.fields[field].type == "card"
        ) {
          continue;
        } else {
          console.log(this.contents.fields[field]);
          this.info[this.contents.fields[field].name] = this.contents.fields[
            field
          ].default
            ? this.contents.fields[field].default
            : "";
        }
      }
    }
    if (
      this.contents.title.includes("Products") &&
      (this.$store.state.shopType == "simple" ||
        this.$store.state.shopType == "custom")
    ) {
      this.pac = false;
    }
    this.info["display"] = true;
    this.modalNode.classList.add("show");
    this.modalNode.classList.add("d-block");
    this.bodyNode.classList.add("modal-open");
    this.bodyNode.style.overflow = "hidden";
  },
  unmounted() {
    try {
      document.body.removeChild(
        document.getElementsByClassName("drawer-overlay")[
        document.getElementsByClassName("drawer-overlay").length - 1
        ]
      );
    } catch (error) {
      console.log("Here");
      console.log(error);
    }
    this.bodyNode.style.overflow = "";
  },
  updated() {
    //
    if (this.enableTimer && !this.verifyTime) {
      this.verifyTime = true;
      this.countDown = 5;
      this.countDownTimer();
    }
    if (this.dropzoneCounter == 0) {
      this.dropzoneInput();
      this.dropzoneCounter += 1;
    }

    this.goto();
  },
  created() {
    this.countDownTimer();
  },
};
</script>

<style scoped>
input::placeholder,
input::-moz-placeholder,
input::-webkit-input-placeholder {
  text-align: start !important;
}

.mh-50vh {
  max-height: 63vh !important;
}

@media (min-width: 1000px) {
  .border-top-lg-0 {
    border-top: 0 !important;
  }
}

.wrong-inputs {
  border: 2px solid !important;
  border-color: red !important;
  /* background-color: #fff; */
}

/*========== SCROLL BAR ==========*/
.modal-body::-webkit-scrollbar {
  width: 0.7rem;
  background-color: var(--scroll-bar-color);
  border-radius: 0.5rem;
}

.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-primary-rgb), 0.6);
  border-radius: 0.5rem;
}

.modal ::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.9);
}

.card:has([data-bs-parent="#chapterAccordion"].collapse.show) {
  border-color: var(--bs-primary) !important;
  box-shadow: 0 0 20px 0 rgba(var(--bs-primary-rgb), 0.5);
}

.card:has([data-bs-parent="#chapterAccordion"].collapse.show)>div:first-child {
  background-color: rgba(var(--bs-primary-rgb), 0.5) !important;
}

button::before {
  font-size: 1.2rem;
}
</style>
